"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var surah,
  nextSurah,
  ruku,
  nextRuku,
  ayahinRuku,
  nextAudioParam,
  nextAudioUrl,
  currentAyaah,
  highlightedAyaah,
  array,
  spns,
  sound,
  nextSound,
  timer,
  ayaahInSurah = 1,
  nextAyaahInRuku = 1,
  nextAyaahInSurah = 1,
  isPlayFromOutside = !1,
  dataId = "1-1",
  userInteract = !1,
  isPlaying = !1;
function showToast(e) {
  var a = document.getElementById("snackbar");
  a.innerHTML = e, a.className = "show", setTimeout(function () {
    a.className = a.className.replace("show", "");
  }, 3e3);
}
var playListenerFunction = function playListenerFunction() {
    getNextRukuUrl(), "function" == typeof qtvAudioStarted && qtvAudioStarted(), timer = setInterval(timeUpdateListenerFunction, 500), document.getElementById("progressDiv1").style.display = "none", $("#btnPlayAudio-Btn").css("display", "none"), $("#btnPauseAudio-Btn").css("display", "inline"), isPlaying = !0;
  },
  endListenerFunction = function endListenerFunction() {
    clearInterval(timer), sound.seek(0), "114" != surah && getSurahRuku();
  },
  pauseListenerFunction = function pauseListenerFunction() {
    clearInterval(timer), "none" == document.getElementById("progressDiv1").style.display ? $("#btnPlayAudio-Btn").css("display", "inline") : $("#btnPlayAudio-Btn").css("display", "none"), $("#btnPauseAudio-Btn").css("display", "none"), isPlaying = !1;
  },
  timeUpdateListenerFunction = function timeUpdateListenerFunction() {
    for (var e = 0; e < array.length; e++) "009" == surah ? Number(getMarkerTime(array[e].time)) <= sound.seek() && (currentAyaah = Number(array[e].id)) : "001" == surah ? 0 < e && Number(getMarkerTime(array[e - 1].time)) <= sound.seek() && (currentAyaah = Number(array[e - 1].id)) : Number(getMarkerTime(array[e].time)) <= sound.seek() && (1 == ayaahInSurah ? currentAyaah = 0 < e ? Number(array[e - 1].id) : Number(array[e].id) : 1 == ruku ? 0 < e && (currentAyaah = Number(array[e - 1].id)) : currentAyaah = Number(array[e].id));
    highlightedAyaah != currentAyaah && (getTotalAyat(surah.replace(/^0+/, ""), spns), $(".qr0").removeClass("qr0_active"));
  };
function isScrolledIntoView(e) {
  var e = ayahBox(e),
    a = e.top,
    e = e.bottom;
  return 0 <= a && e <= window.innerHeight;
}
function scrollToAyat(t) {
  var e = document.getElementById(t);
  if (e) {
    if (!isScrolledIntoView(e)) try {
      $(document).ready(function () {
        void 0 !== t && $("html, body").animate({
          scrollTop: ayahOffsetTop(e) - ($("#topbar").height() + 65)
        }, "slow");
      });
    } catch (e) {
      console.log("scrollToAyat: " + e);
    }
    setTimeout(function () {
      $(".qr0").removeClass("qr0_active"), $("#" + t).addClass("qr0_active"), $("#" + t + "-T").addClass("qr0_active");
    }, 100);
  } else scrollSelections.getAyatRelations().then(function (e) {
    for (var a = 0; a < e.length; a++) if (e[a][0] + "-" + e[a][4] == t) {
      scrollSelections.goToDefinedPage(e[a][9]), setTimeout(function () {
        scrollToAyat(t);
      }, 100);
      break;
    }
  });
}
function getNextRukuUrl() {
  scrollSelections.getAyatRelations().then(function (e) {
    for (var a = 0; a < e.length; a++) if (padLeadingZeros(e[a][0], 3) == surah && e[a][1] == ruku && a < e.length && 1 == e[a + 1][8]) {
      nextSurah = padLeadingZeros(e[a + 1][0], 3), nextRuku = padLeadingZeros(e[a + 1][1], 2), nextAyaahInRuku = e[a + 1][8], nextAyaahInSurah = e[a + 1][4], nextAudioParam = nextSurah + "-" + nextRuku, localforage.getItem("reciterName").then(function (e) {
        nextAudioUrl = "https://q1.pakdata.com/Audio/Script/" + (null != e ? e : "Mishari-Rashid-HQ") + "/" + nextAudioParam + ".mp3", (nextSound = new Howl({
          src: [nextAudioUrl]
        })).load();
      });
      break;
    }
  });
}
function getTotalAyat(r, e) {
  getTotalAyaatPromise().then(function (e) {
    var a = e.TotalAyaat,
      t = 0;
    if (0 < r) {
      for (var e = a[r] - a[r - 1], n = 1; n < r; n++) t += a[n] - a[n - 1];
      var V = t + e;
      scrollSelections.getAyatRelations().then(function (e) {
        for (var a = t; a < V; a++) if (padLeadingZeros(e[a][0], 3) == surah && e[a][1] == ruku && e[a][8] == currentAyaah) {
          dataId = e[a][0] + "-" + e[a][4], highlightedAyaah = currentAyaah, ayaahInSurah = e[a][4], ayahinRuku = currentAyaah;
          break;
        }
        "function" == typeof qtvAyahChanged && qtvAyahChanged(dataId), scrollToAyat(dataId), localforage.setItem("surah_ruku_url_audio", padLeadingZeros(surah, 3) + "-" + padLeadingZeros(ruku, 2)).then(function (e) {})["catch"](function (e) {
          console.log(e);
        }), localforage.setItem("ayaah_ruku_url_audio", currentAyaah).then(function (e) {})["catch"](function (e) {
          console.log(e);
        }), localforage.setItem("ayaah_in_surah", ayaahInSurah).then(function (e) {})["catch"](function (e) {
          console.log(e);
        }), localforage.setItem("ruko_no", ruku).then(function (e) {});
      });
    }
  });
}
function getMarkerTime(e) {
  e = e.split(":");
  return 3600 * e[0] + 60 * e[1] + +e[2];
}
function padLeadingZeros(e, a) {
  for (var t = e + ""; t.length < a;) t = "0" + t;
  return t;
}
function getSurahRuku() {
  surah = nextSurah, ruku = nextRuku, ayahinRuku = nextAyaahInRuku, ayaahInSurah = nextAyaahInSurah, localforage.setItem("surah_ruku_url_audio", padLeadingZeros(surah, 3) + "-" + padLeadingZeros(ruku, 2)).then(function (e) {
    localforage.setItem("ayaah_ruku_url_audio", ayahinRuku).then(function (e) {
      localforage.setItem("ayaah_in_surah", ayaahInSurah).then(function (e) {
        localforage.setItem("ruko_no", ruku).then(function (e) {
          isPlaying = !1, ayahClick();
        });
      });
    });
  })["catch"](function (e) {
    console.log(e);
  });
}
function isInternetAvailable() {
  return !!navigator.onLine;
}
function ayahClick() {
  userInteract || ((sound = new Howl({
    src: ["data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV"]
  })).pause(), userInteract = !0), isPlayFromOutside || (isPlaying ? (document.getElementById("progressDiv1").style.display = "none", $("#btnPlayAudio-Btn").css("display", "inline"), $("#btnPauseAudio-Btn").css("display", "none"), sound.pause()) : isInternetAvailable() ? ($("#btnPlayAudio-Btn").css("display", "none"), $("#btnPauseAudio-Btn").css("display", "none"), document.getElementById("progressDiv1").style.display = "inline", array = [], localforage.getItem("surah_ruku_url_audio").then(function (t) {
    null !== t && (localforage.getItem("ruko_no").then(function (e) {
      ruku = e;
    }), spns = document.querySelectorAll(".qr0"), localforage.getItem("reciterName").then(function (e) {
      var a = "Mishari-Rashid-HQ",
        e = "https://q1.pakdata.com/Audio/Script/" + (a = null != e ? e : a) + "/" + t + ".mp3",
        a = "https://q1.pakdata.com/Audio/Script/" + a + "/" + t + ".xml";
      nextAudioUrl == e ? sound = nextSound : (sound = new Howl({
        src: [e]
      })).load(), surah = t.slice(0, 3), ruku = t.slice(4), sound.on("play", playListenerFunction), sound.on("end", endListenerFunction), sound.on("pause", pauseListenerFunction), fetch(a).then(function (e) {
        return e.text();
      }).then(function (e) {
        for (var a = new DOMParser().parseFromString(e, "text/xml").getElementsByTagName("marker"), t = 0; t < a.length; t++) {
          var n = new Object();
          n.id = a[t].getAttribute("name"), n.time = a[t].getAttribute("time"), array.push(n);
        }
        localforage.getItem("ayaah_ruku_url_audio").then(function (a) {
          var t;
          null !== (ayahinRuku = a) && ("001" == surah || "009" == surah ? (t = Number(getMarkerTime(array[a - 1].time)), sound.seek(t), sound.play()) : localforage.getItem("ayaah_in_surah").then(function (e) {
            1 == (ayaahInSurah = e) ? (t = Number(getMarkerTime(array[a - 1].time)), sound.seek(t), sound.play()) : localforage.getItem("ruko_no").then(function (e) {
              t = 1 == e ? Number(getMarkerTime(array[a].time)) : Number(getMarkerTime(array[a - 1].time)), sound.seek(t), sound.play();
            });
          }));
        })["catch"](function (e) {
          console.log(e);
        });
      })["catch"](console.error);
    }));
  })["catch"](function (e) {
    console.log(e);
  })) : showToast("Internet connection failed"));
}
$(document).on("click", "#btnPlayAudio-Btn, #btnPauseAudio-Btn", ayahClick);
$(".turnOffTranslation").on("click", function (t) {
  window.history.pushState(null, document.title, base_path + "/"), localStorage.setItem("transalatedView", !1), Cookies.set("transalatedoption", "null", {
    expires: 300
  }), window.location.reload();
}), $(".bookmark-modal").on("click", function (t) {
  t.preventDefault(), $("#bookmarkModal").modal("show").find(".modal-content").load($(this).attr("href"));
}), $(".sharing-modal").on("click", function (t) {
  t.preventDefault(), $("#sharingModal").modal("show").find(".modal-content").load($(this).attr("href"));
}), $(".translation-modal").on("click", function (t) {
  t.preventDefault(), $("#translationModal").modal("show").find(".modal-content").load($(this).attr("href"));
}), $(".quranfont-modal").on("click", function (t) {
  t.preventDefault(), $("#quranfontModal").modal("show").find(".modal-content").load($(this).attr("href"));
}), $(".loginArea").on("click", function (t) {
  t.preventDefault(), $("#loginModal").modal("show").find(".modal-content").load($(this).attr("href"));
});
var helpTextData = {
    hints: {
      playAudio: "This button is for playing audio of selected Surah and Ayah.",
      pauseAudio: "This button pauses the audio.",
      emptyReadingBookmark: "This button is for marking a reading bookmark.",
      readingBookmark: "This button shows active reading bookmarks.",
      emptyBookmark: "This button is for marking bookmarks.",
      activeBookmark: "This button shows active bookmarks.",
      openBookmark: "This button opens a list of bookmarks where you can edit bookmarks from a list after log in.",
      turnOnTranslationView: "This button opens a list of translations and after selecting turns on translation view.",
      turnOffTranslationView: "This button turns off translation view.",
      fontView: "This button opens a list of fonts and by selecting opens the selected font view i.e uthmanic or indopak.",
      sharing: "This button opens the sharing modal where you can share Ayah and surah.",
      download: "This button redirects to playstore/applestore where you can download the mobile app."
    }
  },
  helpDetails = document.querySelector(".help-details");
var helpDetailshide = document.getElementById("helpDetails");
var bottomNav = document.getElementById("bottomNav");
function showHelp() {
  bottomNav.style.height = "max-content" == bottomNav.style.height ? "50vh" : "max-content", helpDetailshide.style.display = "none" === helpDetailshide.style.display || "" === helpDetailshide.style.display ? "block" : "none", document.getElementById("versionParagraph").style.display = "block" === helpDetailshide.style.display ? "inline" : "none", "50vh" === bottomNav.style.height ? helpDetails.innerHTML = "\n        <div style=\"display:flex; justify-content:center; border: 1px solid black; color: white; background: #00592f; border-radius: 5px\">\n          <p class=\"hint-heading\">Help/Hints</p>\n        </div>\n        <ul>\n          <li>\n            <img class=\"help-icon\" src=\"".concat(base_path, "/images/play.png\" alt=\"Play Audio\">\n            <strong>Play Audio Button:</strong> ").concat(helpTextData.hints.playAudio, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/pause.png\" alt=\"Pause Audio\">\n            <strong>Pause Audio Button:</strong> ").concat(helpTextData.hints.pauseAudio, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/reading_bookmark_deactive.png\" alt=\"Empty Reading Bookmark\">\n            <strong>Empty Reading Bookmark Button:</strong> ").concat(helpTextData.hints.emptyReadingBookmark, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/reading_bookmark_active.png\" alt=\"Reading Bookmark\">\n            <strong>Reading Bookmark Button:</strong> ").concat(helpTextData.hints.readingBookmark, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/bookmarkempty.png\" alt=\"Empty Bookmark\">\n            <strong>Empty Bookmark Button:</strong> ").concat(helpTextData.hints.emptyBookmark, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/bookmark.png\" alt=\"Bookmark\">\n            <strong>Bookmark Button:</strong> ").concat(helpTextData.hints.activeBookmark, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/openBookmark.png\" alt=\"Open Bookmark\">\n            <strong>Open Bookmark Button:</strong> ").concat(helpTextData.hints.openBookmark, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/translation_off_dark.png\" alt=\"Turn on Translation View\">\n            <strong>Turn on Translation View Button:</strong> ").concat(helpTextData.hints.turnOnTranslationView, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/translation_on.png\" alt=\"Turn off Translation View\">\n            <strong>Turn off Translation View Button:</strong> ").concat(helpTextData.hints.turnOffTranslationView, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/fontimg.png\" alt=\"Font View\">\n            <strong>Font View Button:</strong> ").concat(helpTextData.hints.fontView, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/sharing.png\" alt=\"Sharing\">\n            <strong>Sharing Button:</strong> ").concat(helpTextData.hints.sharing, "\n          </li>\n          <li>\n            <img class=\"help-icon\" src=\"").concat(base_path, "/images/download.png\" alt=\"Download\">\n            <strong>Download Button:</strong> ").concat(helpTextData.hints.download, "\n          </li>\n        </ul>\n      ") : helpDetails.innerHTML = "";
}
bottomNav.style.height = "max-content";
function DownLoadApp() {
  window.open("https://play.google.com/store/apps/details?id=com.pakdata.QuranMajeed", "_blank");
}
function loginFirebase() {
  firebase.auth().signInWithPopup(provider).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var n, l, o;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            n = document.getElementById("cover-spin");
            l = document.getElementById("login-button-div"), l = (null !== e.user.email && void 0 !== e.user.email && (l.style.display = "none", n.style.display = "flex"), e.credential.accessToken, e.user), e = l.email, o = l.uid, l = l.displayName;
            fetch(backend_url_local + "/storeSession", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                name: l,
                email: e,
                uid: o,
                photoUrl: "null",
                emailVerified: "null"
              })
            }).then(function (e) {
              return e.json();
            }).then(function (e) {
              console.log(e), window.close(), n.style.display = "flex";
            })["catch"](function (e) {
              return console.error(e);
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }())["catch"](function (e) {
    e.code, e.message, e.email;
  });
}
var qtvOpen = !1,
  qtvShownId = "",
  qtvPendingId = "",
  qtvQueuedId = "",
  qtvQueuedIds = [],
  qtvFetching = !1,
  qtvOffset = 0,
  qtvSpeed = 10,
  qtvMinSpeed = 4,
  qtvMaxSpeed = 200,
  qtvHoldLine = .5,
  qtvLookAhead = 2.5,
  qtvFrame = null,
  qtvLastFrame = 0,
  qtvLastBottom = 0,
  qtvGap = 16,
  qtvSuraNames = null;
function qtvIsAyahId(t) {
  return "string" == typeof t && /^\d+-\d+$/.test(t);
}
function qtvStartId() {
  if (isPlaying && qtvIsAyahId(dataId)) return dataId;
  if (qtvIsAyahId(lastId)) return lastId;
  for (var t = document.querySelectorAll(".qr0"), e = 0; e < t.length; e++) {
    var n = t[e].id;
    if (qtvIsAyahId(n)) {
      var a = ayahBox(t[e]);
      if (0 < a.bottom && a.top < window.innerHeight) return n;
    }
  }
  return "1-1";
}
function qtvAyahIndex(t) {
  var e = parseInt(t.split("-")[0]),
    t = parseInt(t.split("-")[1]);
  return totalAyaat[e - 1] + t - 1;
}
function qtvIdOfIndex(t) {
  for (var e = 1; e <= 114; e++) if (t < totalAyaat[e]) return e + "-" + (t - totalAyaat[e - 1] + 1);
  return "";
}
function qtvNextId(t) {
  t = qtvAyahIndex(t) + 1;
  return 6236 < t ? "" : qtvIdOfIndex(t);
}
function qtvShow(t) {
  qtvIsAyahId(t) || (t = qtvStartId());
  var e = document.getElementById("qtv");
  qtvOpen = !0, e.classList.add("qtv-open"), e.setAttribute("aria-hidden", "false"), qtvPlayVideo(), qtvResetCrawl(), qtvStartCrawl(), getSurahNamesPromise().then(function (t) {
    qtvSuraNames = t.SurahEnglishNames;
  }), isPlaying ? (qtvSetStatus(""), qtvAyahChanged(t)) : isInternetAvailable() ? (qtvPendingId = t, qtvSetStatus("loading"), "none" == document.getElementById("progressDiv1").style.display && qtvStartAudio(t), qtvAutoOpened && (qtvTapHintTimer = setTimeout(function () {
    qtvOpen && !isPlaying && qtvSetStatus("Tap anywhere to start the recitation");
  }, 2500))) : qtvSetStatus("Audio needs an internet connection");
}
var qtvAutoOpened = !1,
  qtvTapHintTimer = null;
function qtvOpenOnLoad() {
  qtvAutoOpened = !0, localforage.getItem("surah_ruku_url_audio").then(function (e) {
    return localforage.getItem("ayaah_in_surah").then(function (t) {
      return e && t ? parseInt(e.slice(0, 3), 10) + "-" + t : "1-1";
    });
  })["catch"](function () {
    return "1-1";
  }).then(function (t) {
    qtvShow(t);
  });
}
function qtvHide() {
  var t = document.getElementById("qtv"),
    t = (qtvOpen = !1, qtvPendingId = "", clearTimeout(qtvTapHintTimer), qtvAutoOpened && (qtvAutoOpened = !1, window.history.replaceState(null, document.title, base_path + "/")), t.classList.remove("qtv-open"), t.setAttribute("aria-hidden", "true"), qtvStopCrawl(), document.getElementById("qtvVideoPlayer"));
  t && t.pause();
}
function qtvSetStatus(t) {
  var e = document.getElementById("qtvStatus");
  e.classList.toggle("qtv-status-loading", "loading" === t), e.classList.toggle("qtv-status-shown", "" !== t), document.getElementById("qtvStatusText").textContent = "loading" === t ? "" : t;
}
function qtvPlayVideo() {
  var t = document.getElementById("qtvVideoPlayer"),
    t = (t || ((t = document.createElement("video")).id = "qtvVideoPlayer", t.setAttribute("playsinline", "playsinline"), t.muted = !0, t.loop = !0, t.src = base_path + "/assets/Clouds-Sky_hd.m4v", document.getElementById("qtvVideo").appendChild(t)), t.play());
  t && t["catch"] && t["catch"](function () {});
}
function qtvStartAudio(t) {
  var a = parseInt(t.split("-")[0]),
    r = parseInt(t.split("-")[1]);
  scrollSelections.getAyatRelations().then(function (t) {
    for (var e = 0; e < t.length; e++) if (t[e][0] === a && t[e][4] === r) {
      var n = t[e];
      Promise.all([localforage.setItem("surah_ruku_url_audio", padLeadingZeros(n[0], 3) + "-" + padLeadingZeros(n[1], 2)), localforage.setItem("ayaah_ruku_url_audio", n[8]), localforage.setItem("ayaah_in_surah", n[4]), localforage.setItem("ruko_no", n[1])]).then(function () {
        isPlaying || ayahClick();
      })["catch"](function (t) {
        console.log(t);
      });
      break;
    }
  });
}
function qtvAudioStarted() {
  var t;
  qtvOpen && (clearTimeout(qtvTapHintTimer), qtvSetStatus(""), t = qtvPendingId || dataId, qtvPendingId = "", qtvAyahChanged(t));
}
function qtvAyahChanged(t) {
  qtvOpen && qtvIsAyahId(t) && t !== qtvShownId && (qtvShownId = t, -1 == qtvQueuedIds.indexOf(t) && (qtvResetCrawl(), qtvQueueAyah(t)), qtvSetCurrent(t));
}
function qtvSetCurrent(t) {
  for (var e = document.getElementById("qtvCrawl").children, n = 0; n < e.length; n++) e[n].classList.toggle("qtv-current", e[n].getAttribute("data-id") === t);
  var a = parseInt(t.split("-")[0]),
    r = parseInt(t.split("-")[1]);
  document.getElementById("qtvLabel").textContent = (qtvSuraNames ? qtvSuraNames[a - 1] : "") + "  " + a + ":" + r, qtvSetSpeedForAyah();
}
function qtvSetSpeedForAyah() {
  var t,
    e = document.getElementById("qtvCrawl").querySelector(".qtv-current"),
    n = qtvSecondsToNextAyah();
  e && null !== n && (t = document.getElementById("qtvStage").clientHeight, e = (e.offsetTop + e.offsetHeight - qtvOffset - t * qtvHoldLine) / Math.max(n, .5), qtvSpeed = Math.min(qtvMaxSpeed, Math.max(qtvMinSpeed, e)));
}
function qtvSecondsToNextAyah() {
  if (!isPlaying || "object" != _typeof(sound) || !sound || !Array.isArray(array) || 0 == array.length) return null;
  var t = sound.seek();
  if ("number" != typeof t) return null;
  for (var e, n = null, a = 0; a < array.length; a++) {
    var r = Number(getMarkerTime(array[a].time));
    t + .2 < r && (null === n || r < n) && (n = r);
  }
  return null === (n = null === n ? 0 < (e = sound.duration()) ? e : null : n) ? null : n - t;
}
function qtvQueueAyah(n) {
  qtvQueuedId = n, qtvQueuedIds.push(n), qtvFetching = !0, fetch(base_path + "/cache/" + fontfolderName + "/" + qtvAyahIndex(n) + ".json").then(function (t) {
    return t.json();
  }).then(function (t) {
    var e;
    qtvOpen && -1 != qtvQueuedIds.indexOf(n) && ((e = document.createElement("div")).className = "qtv-ayah", e.setAttribute("data-id", n), e.innerHTML = t.DATA.replace(/^\s*<br\s*\/?>/i, ""), qtvPlaceAyah(e), n === qtvShownId) && qtvSetCurrent(n);
  })["catch"](function (t) {
    console.log("qtv: " + t);
  }).then(function () {
    qtvFetching = !1;
  });
}
function qtvPlaceAyah(t) {
  var e = document.getElementById("qtvCrawl"),
    n = qtvLastBottom + qtvGap;
  0 == e.children.length && (n = Math.max(n, qtvOffset + document.getElementById("qtvStage").clientHeight)), t.style.top = n + "px", e.appendChild(t), qtvLastBottom = n + t.offsetHeight;
}
function qtvTopUp() {
  var t;
  !qtvFetching && qtvQueuedId && (t = document.getElementById("qtvStage").clientHeight, qtvLastBottom - qtvOffset < t * qtvLookAhead) && ((t = qtvNextId(qtvQueuedId)) ? qtvQueueAyah(t) : qtvQueuedId = "");
}
function qtvResetCrawl() {
  var t = document.getElementById("qtvCrawl");
  t.innerHTML = "", t.style.transform = "translateY(0)", qtvLastBottom = qtvOffset = 0, qtvQueuedId = "", qtvQueuedIds = [];
}
function qtvStartCrawl() {
  null === qtvFrame && (qtvLastFrame = performance.now(), qtvFrame = requestAnimationFrame(qtvCrawlFrame));
}
function qtvStopCrawl() {
  null !== qtvFrame && (cancelAnimationFrame(qtvFrame), qtvFrame = null);
}
function qtvCrawlFrame(t) {
  for (var e = Math.min(.1, (t - qtvLastFrame) / 1e3), n = (qtvLastFrame = t, document.getElementById("qtvCrawl")), a = (qtvOffset += qtvSpeed * e, n.style.transform = "translateY(" + -qtvOffset + "px)", n.firstElementChild); a && a.offsetTop + a.offsetHeight - qtvOffset < -300;) n.removeChild(a), a = n.firstElementChild;
  qtvTopUp(), qtvFrame = requestAnimationFrame(qtvCrawlFrame);
}
$(document).on("click", "#btnQtv-Btn", function () {
  qtvShow();
}), $(function () {
  "undefined" != typeof qtv_mode && qtv_mode && qtvOpenOnLoad();
}), $(document).on("click", "#qtvClose", qtvHide), $(document).on("keydown", function (t) {
  qtvOpen && "Escape" === t.key && qtvHide();
});
var ayatRelations = [],
  juzmarkRelations = [],
  juzmarkRelationsUsmanic = [],
  sajdamarkRelations = [],
  rubamarkRelations = [],
  nisfmarkRelations = [],
  salasamarkRelations = [],
  hizbmarkRelations = [],
  rubamarkRelationsUsmanic = [],
  nisfmarkRelationsUsmanic = [],
  salasamarkRelationsUsmanic = [],
  globalRuku = 0,
  globalJuz = 1,
  count = 1,
  provider = new firebase.auth.GoogleAuthProvider();
var scrollHeight = 0;
var engSurahNames = [],
  surahNameList = [],
  isWorking = !1;
var startFromAyat, endOnAyat, startAfterCallApi, endAfterCallApi;
var scrollSelections = function () {
  var g,
    t = localStorage.getItem("fontsizeVal"),
    e = parseFloat(t),
    t = ($(document).ready(function () {
      function t() {
        var t = localStorage.getItem("fontsizeVal");
        parseFloat(t) < .8 && (g = 15);
      }
      $(".incdec").bind("click", function () {
        t();
      }), $(".fontprogress").change(function () {
        t();
      });
    }), window.outerWidth ? (window.outerWidth - 10) / window.innerWidth * 100 : 100),
    a = (e < .8 ? g = 15 : (g = 5, t < 90 && (65 <= t ? g = 10 : t < 65 && 45 <= t ? g = 20 : t < 45 && (g = 30))), $(window).resize(function () {
      var t = (window.outerWidth - 10) / window.innerWidth * 100,
        t = (e < .8 ? g = 15 : (g = 5, t < 90 && (65 <= t ? g = 10 : t < 65 && 45 <= t ? g = 20 : t < 45 && (g = 30))), localStorage.getItem("transalatedView"));
      "true" === t && (t = window.innerWidth < 769 ? {
        paddingLeft: "0px",
        paddingRight: "35px"
      } : {
        paddingLeft: "0.5em",
        paddingRight: "0.5em"
      }, $(".arabic").css(t));
    }), window.onscroll = function (t) {
      var e,
        a = navigator.userAgent || navigator.vendor || window.opera;
      /iPhone/.test(a) && !window.MSStream && null != (a = document.getElementById("bottomBar")) && ((e = window.scrollY) > (scrollHeight = 0 !== scrollHeight && null !== scrollHeight && void 0 !== scrollHeight ? scrollHeight : e) && (a.style.paddingBottom = "20px", scrollHeight = e), e < scrollHeight) && (a.style.paddingBottom = "5px", scrollHeight = e);
    }, []),
    i = [],
    f = 1,
    h = [],
    s = [604, 610],
    c = 1,
    n = "none",
    o = "none";
  var dt = function dt(t) {
      return new Promise(function (e, n) {
        $.ajax({
          url: base_path + "/cache/translationData/".concat(t, "/surahName.json"),
          dataType: "json",
          cache: !0,
          success: function success(t) {
            e(t);
          },
          error: function error(t, e, a) {
            n("error");
          },
          complete: function complete() {}
        });
      });
    },
    l = function l() {
      return new Promise(function (e, n) {
        localforage.getItem("rubamarkwithAyat").then(function (t) {
          null === t ? $.ajax({
            url: base_path + "/JSONFiles/rubamarkwithAyatRelation.json",
            dataType: "json",
            cache: !0,
            success: function success(t) {
              localforage.setItem("rubamarkwithAyat", t.rubamarkwithAyats).then(function (t) {
                e(t);
              })["catch"](function (t) {
                n(t);
              });
            },
            error: function error(t, e, a) {
              n("error");
            },
            complete: function complete() {}
          }) : e(t);
        })["catch"](function (t) {
          console.log(t), n(t);
        });
      });
    },
    O = function O() {
      return new Promise(function (e, n) {
        localforage.getItem("nisfmarkwithAyat").then(function (t) {
          null === t ? $.ajax({
            url: base_path + "/JSONFiles/nisfmarkwithAyatRelation.json",
            dataType: "json",
            cache: !0,
            success: function success(t) {
              localforage.setItem("nisfmarkwithAyat", t.nisfmarkwithAyats).then(function (t) {
                e(t);
              })["catch"](function (t) {
                n(t);
              });
            },
            error: function error(t, e, a) {
              n("error");
            },
            complete: function complete() {}
          }) : e(t);
        })["catch"](function (t) {
          console.log(t), n(t);
        });
      });
    },
    T = function T() {
      return new Promise(function (e, n) {
        localforage.getItem("salasamarkwithAyat").then(function (t) {
          null === t ? $.ajax({
            url: base_path + "/JSONFiles/salasamarkwithAyatRelation.json",
            dataType: "json",
            cache: !0,
            success: function success(t) {
              localforage.setItem("salasamarkwithAyat", t.salasamarkwithAyats).then(function (t) {
                e(t);
              })["catch"](function (t) {
                n(t);
              });
            },
            error: function error(t, e, a) {
              n("error");
            },
            complete: function complete() {}
          }) : e(t);
        })["catch"](function (t) {
          console.log(t), n(t);
        });
      });
    },
    gt = function gt() {
      return new Promise(function (e, n) {
        localforage.getItem("juzmarkwithAyat").then(function (t) {
          null === t ? $.ajax({
            url: base_path + "/JSONFiles/juzmarkwithAyatRelation.json",
            dataType: "json",
            cache: !0,
            success: function success(t) {
              localforage.setItem("juzmarkwithAyat", t.juzmarkwithAyats).then(function (t) {
                e(t);
              })["catch"](function (t) {
                n(t);
              });
            },
            error: function error(t, e, a) {
              n("error");
            },
            complete: function complete() {}
          }) : e(t);
        })["catch"](function (t) {
          console.log(t), n(t);
        });
      });
    },
    ft = function ft() {
      return new Promise(function (e, n) {
        localforage.getItem("juzmarkwithAyatUsmanic").then(function (t) {
          null === t ? $.ajax({
            url: base_path + "/JSONFiles/juzmarkwithAyatRelationUsmanic.json",
            dataType: "json",
            cache: !0,
            success: function success(t) {
              localforage.setItem("juzmarkwithAyatUsmanic", t.juzmarkwithAyats).then(function (t) {
                e(t);
              })["catch"](function (t) {
                n(t);
              });
            },
            error: function error(t, e, a) {
              n("error");
            },
            complete: function complete() {}
          }) : e(t);
        })["catch"](function (t) {
          console.log(t), n(t);
        });
      });
    },
    u = function u() {
      return new Promise(function (e, n) {
        var t = JSON.parse(localStorage.getItem("seletedQuranFont"));
        fontfolderName = null == t ? 1 == isArabicCountry ? (currentScript = "Uthmanic", selectionOfScriptNo = 5, "dataUsmani") : (currentScript = "IndoPak", selectionOfScriptNo = 9, "data") : (currentScript = t[0], selectionOfScriptNo = t[1], t[2]), localforage.getItem("pageRelationsWithAyats" + currentScript).then(function (t) {
          null === t ? $.ajax({
            url: "".concat(base_path, "/JSONFiles/pageRelationsWithAyats").concat(currentScript, ".json"),
            dataType: "json",
            cache: !0,
            success: function success(t) {
              localforage.setItem("pageRelationsWithAyats" + currentScript, t.pageRelationsWithAyats).then(function (t) {
                e(t);
              })["catch"](function (t) {
                n(t);
              });
            },
            error: function error(t, e, a) {
              n("error");
            },
            complete: function complete() {}
          }) : e(t);
        })["catch"](function (t) {
          console.log(t), n(t);
        });
      });
    };
  function ht(t) {
    return (t + "").replaceAll("1", "١").replaceAll("2", "٢").replaceAll("3", "٣").replaceAll("4", "٤").replaceAll("5", "٥").replaceAll("6", "٦").replaceAll("7", "٧").replaceAll("8", "٨").replaceAll("9", "٩").replaceAll("0", "٠");
  }
  function m(t) {
    return t.getBoundingClientRect().top + window.pageYOffset;
  }
  function p(t, e) {
    $(window).scrollTop(e);
    var a = e - (document.documentElement.scrollHeight - window.innerHeight);
    0 < a && (t.css("padding-bottom", y(t) + Math.ceil(a) + "px"), $(window).scrollTop(e));
  }
  function y(t) {
    return parseFloat(t.css("padding-bottom")) || 0;
  }
  var r = !1;
  function x() {
    return localforage.getItem("surah_ruku_url_audio").then(function (e) {
      return localforage.getItem("ayaah_in_surah").then(function (t) {
        return e && t ? parseInt(e.slice(0, 3), 10) + "-" + t : null;
      });
    })["catch"](function () {
      return null;
    });
  }
  function w(t, e) {
    e = e && !r ? document.getElementById(e) : null;
    e && (p(t, ayahOffsetTop(e) - ($("#topbar").height() + 112)), r = !0);
  }
  function d(t, e, a) {
    var a = JSON.parse(a),
      n = [];
    n.push(a.DATA);
    (n = []).push(a.DATA);
    var o,
      r,
      i,
      l,
      s,
      c = $("<div class='list-chunk'></div>"),
      u = $("<div class='list-item'></div>"),
      d = (c.append(u), $("<div class='details'></div>"));
    d.append(n.join("")), u.append(d), c.data("minOffset", a.OFFSET), c.data("maxOffset", a.OFFSET), $("#quranText").fadeOut(500), $("#container").fadeIn(1e3), "top" == e ? (o = $(window).scrollTop(), i = (r = t.children(":first")[0]) ? m(r) : 0, t.prepend(c), h.lastIndexOf(f) < 0 && (h.reverse(), h.push(document.getElementById("page" + f)), h.reverse()), p(t, o + (l = r ? m(r) - i : c.outerHeight(!0))), t.children().length > g && (t.find("> div.list-chunk:last").remove(), h.pop())) : ($(".loading").html(""), $("#quranText").fadeOut(500), $("#container").fadeIn(1e3), n = 0 == t.children().length, t.append(c), 0 < y(t) && t.css("padding-bottom", Math.max(0, y(t) - c.outerHeight(!0)) + "px"), n && (s = t, suraClickedCheck || (-1 != parseInt(suraClickedNo) ? w(s, suraClickedNo + "-" + (highlightAyaNo || 1)) : x().then(function (t) {
      w(s, t);
    }))), h.lastIndexOf(f) < 0 && h.push(document.getElementById("page" + f)), t.children().length > g && (o = $(window).scrollTop(), u = t.children(":first"), i = (r = t.children().eq(1)[0]) ? m(r) : 0, u.remove(), h.shift(), l = r ? i - m(r) : 0, $(window).scrollTop(o - l)), t.children().length == g && ($(".arabic").animate({
      opacity: 1
    }, 200), 0 < jScrollTop && $(document).scrollTop(window.jScrollTop), window.jScrollTop = 0), 590 < f && $(".arabic").animate({
      opacity: 1
    }, 200)), t.data("minOffset", t.children(":first").data("minOffset")), t.data("maxOffset", t.children(":last").data("maxOffset"));
    try {
      document.getElementById("progressDiv").style.display = "none";
    } catch (t) {
      console.log("progressDiv null");
    }
    $(".buttons").css("pointer-events", "visible");
  }
  function k(_x2) {
    return _k.apply(this, arguments);
  }
  function _k() {
    _k = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(t) {
      var e;
      return _regeneratorRuntime().wrap(function _callee9$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            b++, document.getElementById("container").innerHTML = "", $("#container").html("");
            e = $("#container");
            e.css("padding-bottom", ""), r = !1, window.page = t, e.removeData("xhr"), e.removeData("minOffset"), e.removeData("maxOffset"), S(e), window.page = t, jQuery(function (e) {
              var a = e("#container");
              e(window).bind("scroll resize", function (t) {
                scrollAllowed && 0 == isWorking && (S(a), e(".sura_mark").each(function (t) {}));
              }), e(".incdec").bind("click", function () {
                scrollAllowed && 0 == isWorking && (S(a), e(".sura_mark").each(function (t) {}));
              }), e(".fontprogress").change(function () {
                scrollAllowed && 0 == isWorking && (S(a), e(".sura_mark").each(function (t) {}));
              }), S(a);
            }), (e = document.getElementById("arabic1")).style.zoom = "100%", e.style.zoom.slice(0, -1);
          case 3:
          case "end":
            return _context10.stop();
        }
      }, _callee9);
    }));
    return _k.apply(this, arguments);
  }
  var b = 0;
  function v() {
    S($("#container"));
  }
  function S(t) {
    function e() {
      S(t);
    }
    var a,
      n = JSON.parse(localStorage.getItem("seletedQuranFont")),
      n = (null == n ? 1 == isArabicCountry && $(".sura_mark").css("padding-left", "15px") : null != n && 5 == (selectionOfScriptNo = n[1]) && $(".sura_mark").css("padding-left", "15px"), isWorking = !0, R(t));
    if (n.top && t.data("minOffset") && 1 < t.data("minOffset")) {
      A(t, "top", e);
      try {
        document.getElementById("progressDiv").style.display = "block";
      } catch (t) {
        console.log("progressDiv null");
      }
    } else if (n.bottom) {
      A(t, "bottom", e);
      try {
        document.getElementById("progressDiv").style.display = "block";
      } catch (t) {
        console.log("progressDiv null");
      }
    } else 0 == suraClickedCheck && (suraClickedCheck = !0, -1 != parseInt(suraClickedNo) ? (count++, a = suraClickedNo, n = (n = highlightAyaNo) || 1, void 0 !== (n = (suraClickedNo + "-" + n).toString()) && !r && $("#" + n).length && $("html, body").scrollTop(ayahOffsetTop($("#" + n)[0]) - ($("#topbar").height() + 112)), count = 0, previousSura != a && getSurahNamesPromise().then(function (t) {
      t = t.SurahEnglishNames[a - 1];
      $(".b_sura").text(t), previousSura = a;
    })) : x().then(function (t) {
      w($("#container"), t);
    }));
  }
  function A(e, a, n) {
    var t,
      o,
      r,
      i = JSON.parse(localStorage.getItem("seletedQuranFont"));
    null == i ? 1 == isArabicCountry && (c = 0) : null != i && 5 == i[1] && (c = 0), e.data("xhr") || (0 < parseInt(window.page) ? window.page = window.page - 1 : window.page = window.jPageNumber - 1, window.page > s[c] - 1 && (window.page = s[c] - 1), i = e.data("minOffset") || +Number(window.page), t = e.data("maxOffset") || Number(window.page) + 0, o = "top" == a ? i - 1 : t + 1, r = b, e.data("xhr", I(o).then(function (t) {
      r == b && (d(e, a, t), f = o, e.removeData("xhr"), n());
    })), firstTime += 1);
  }
  function R(t) {
    navigator.onLine ? document.getElementById("offlineModetext").style.display = "none" : document.getElementById("offlineModetext").style.display = "block";
    var e,
      a = {
        top: !1,
        bottom: !1
      },
      n = $(document).scrollTop(),
      o = n + $(window).height(),
      r = t.offset().top,
      i = Math.floor(r + t.height());
    e = window.page == t.data("minOffset") - 1 ? 500 : 200;
    var l = 1e3,
      n = (NaN != $(document).height() && (l = $(document).height() / 2.5), n <= r + e && (a.top = !0), t.data("maxOffset"));
    return t.children().length < g ? Number(n) < s[c] && (a.bottom = !0) : (scrollAllowed = !0, isWorking = !1), i - l <= o && (a.bottom = !0), Number(n) > s[c] - 1 && (scrollAllowed = !0, isWorking = !1, a.bottom = !1), 700 < Number(n) && (a.bottom = !1, a.top = !1), Number(n) == s[c] && t.children().length < 3 && (a.top = !0), a;
  }
  var I = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(r) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (l().then(function (t) {
                for (var e in rubamarkRelations = [], t) rubamarkRelations.push(t[e]);
              }), O().then(function (t) {
                for (var e in nisfmarkRelations = [], t) nisfmarkRelations.push(t[e]);
              }), T().then(function (t) {
                for (var e in salasamarkRelations = [], t) salasamarkRelations.push(t[e]);
              }), new Promise(function (n, o) {
                u().then(function (t) {
                  var e,
                    a = JSON.parse(localStorage.getItem("seletedQuranFont"));
                  fontfolderName = null == a ? 1 == isArabicCountry ? (currentScript = "Uthmanic", selectionOfScriptNo = 5, "dataUsmani") : (currentScript = "IndoPak", selectionOfScriptNo = 9, "data") : (currentScript = a[0], selectionOfScriptNo = a[1], a[2]), i = t, a = 9 == selectionOfScriptNo ? (i[r - 1][0], e = i[r - 1][1], i[r - 1][2]) : (i[r - 1][2], e = i[r - 1][0], i[r - 1][1]), j(!1, r, e, a).then(function (t) {
                    t = F(r, t), t = N(r, t);
                    t ? n(t) : o("err");
                  });
                });
              })));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function I(_x3) {
        return _ref2.apply(this, arguments);
      };
    }(),
    j = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(U, M, C, B, t) {
        var a, J, e, l, n, o, L, r, s, c, E, Q, H, W, i, _loop, u, q, d, g, V, f, h, G, m, Y, X, p, Z, K, tt, y, x, w, k, b, v, S, A, R, et, at, nt, ot, I, rt, it, lt, j, N, F, z, _, st, ct, O, ut, T, P, D, _ret;
        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              gt().then(function (t) {
                for (var e in juzmarkRelations = [], t) juzmarkRelations.push(t[e]);
              }), ft().then(function (t) {
                for (var e in juzmarkRelationsUsmanic = [], t) juzmarkRelationsUsmanic.push(t[e]);
              }), new Promise(function (e, n) {
                localforage.getItem("sajdamarkwithAyat").then(function (t) {
                  null === t ? $.ajax({
                    url: base_path + "/JSONFiles/sajdamarkwithAyatRelation.json",
                    dataType: "json",
                    cache: !0,
                    success: function success(t) {
                      localforage.setItem("sajdamarkwithAyat", t.sajdamarkwithAyats).then(function (t) {
                        e(t);
                      })["catch"](function (t) {
                        n(t);
                      });
                    },
                    error: function error(t, e, a) {
                      n("error");
                    },
                    complete: function complete() {}
                  }) : e(t);
                })["catch"](function (t) {
                  console.log(t), n(t);
                });
              }).then(function (t) {
                for (var e in sajdamarkRelations = [], t) sajdamarkRelations.push(t[e]);
              }), new Promise(function (e, n) {
                localforage.getItem("hizbmarkwithAyatUsmanic").then(function (t) {
                  null === t ? $.ajax({
                    url: base_path + "/JSONFiles/hizbmarkwithAyatRelation.json",
                    dataType: "json",
                    cache: !0,
                    success: function success(t) {
                      localforage.setItem("hizbmarkwithAyatUsmanic", t.hizbmarkwithAyats).then(function (t) {
                        e(t);
                      })["catch"](function (t) {
                        n(t);
                      });
                    },
                    error: function error(t, e, a) {
                      n("error");
                    },
                    complete: function complete() {}
                  }) : e(t);
                })["catch"](function (t) {
                  console.log(t), n(t);
                });
              }).then(function (t) {
                for (var e in hizbmarkRelations = [], t) hizbmarkRelations.push(t[e]);
              }), new Promise(function (e, n) {
                localforage.getItem("rubamarkwithAyatUsmanic").then(function (t) {
                  null === t ? $.ajax({
                    url: base_path + "/JSONFiles/rubamarkwithAyatRelationUsmanic.json",
                    dataType: "json",
                    cache: !0,
                    success: function success(t) {
                      localforage.setItem("rubamarkwithAyatUsmanic", t.rubamarkwithAyatsUsmanic).then(function (t) {
                        e(t);
                      })["catch"](function (t) {
                        n(t);
                      });
                    },
                    error: function error(t, e, a) {
                      n("error");
                    },
                    complete: function complete() {}
                  }) : e(t);
                })["catch"](function (t) {
                  console.log(t), n(t);
                });
              }).then(function (t) {
                for (var e in rubamarkRelationsUsmanic = [], t) rubamarkRelationsUsmanic.push(t[e]);
              }), new Promise(function (e, n) {
                localforage.getItem("nisfmarkwithAyatUsmanic").then(function (t) {
                  null === t ? $.ajax({
                    url: base_path + "/JSONFiles/nisfmarkwithAyatRelationUsmanic.json",
                    dataType: "json",
                    cache: !0,
                    success: function success(t) {
                      localforage.setItem("nisfmarkwithAyatUsmanic", t.nisfmarkwithAyatsUsmanic).then(function (t) {
                        e(t);
                      })["catch"](function (t) {
                        n(t);
                      });
                    },
                    error: function error(t, e, a) {
                      n("error");
                    },
                    complete: function complete() {}
                  }) : e(t);
                })["catch"](function (t) {
                  console.log(t), n(t);
                });
              }).then(function (t) {
                for (var e in nisfmarkRelationsUsmanic = [], t) nisfmarkRelationsUsmanic.push(t[e]);
              }), new Promise(function (e, n) {
                localforage.getItem("salasamarkwithAyatUsmanic").then(function (t) {
                  null === t ? $.ajax({
                    url: base_path + "/JSONFiles/salasamarkwithAyatRelationUsmanic.json",
                    dataType: "json",
                    cache: !0,
                    success: function success(t) {
                      localforage.setItem("salasamarkwithAyatUsmanic", t.salasamarkwithAyatsUsmanic).then(function (t) {
                        e(t);
                      })["catch"](function (t) {
                        n(t);
                      });
                    },
                    error: function error(t, e, a) {
                      n("error");
                    },
                    complete: function complete() {}
                  }) : e(t);
                })["catch"](function (t) {
                  console.log(t), n(t);
                });
              }).then(function (t) {
                for (var e in salasamarkRelationsUsmanic = [], t) salasamarkRelationsUsmanic.push(t[e]);
              });
              o = JSON.parse(localStorage.getItem("seletedQuranFont")), L = null == o ? 1 == isArabicCountry ? (e = "Uthmanic", selectionOfScriptNo = 5, "dataUsmani") : (e = "IndoPak", selectionOfScriptNo = 9, "data") : (e = o[0], selectionOfScriptNo = o[1], o[2]), r = localStorage.getItem("transalatedView"), s = localStorage.getItem("transalatedoption"), o = localStorage.getItem("translationsizeVal"), o = (parseFloat(o), localStorage.getItem("fontsizeVal")), c = parseFloat(o), E = 100 * c / 5 - 9, Q = (null == o && (E = 100 * (c = 1) / 5 - 9), localStorage.setItem("fontsizeProgress", E), J = c <= .7 ? "-5px" : "0px", "");
              H = !1, W = !1;
              startFromAyat = C, endOnAyat = B;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var _o, _r, _i, _n;
                return _regeneratorRuntime().wrap(function _loop$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      q = u.toString(), d = u;
                      _context4.next = 3;
                      return localforage.getItem(e + "" + q).then( /*#__PURE__*/function () {
                        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(t) {
                          var e;
                          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                            while (1) switch (_context3.prev = _context3.next) {
                              case 0:
                                if (!(null !== t)) {
                                  _context3.next = 4;
                                  break;
                                }
                                a = t, H = !0, document.getElementById("offlineReloadtext").style.display = "none", $("#preview").addClass("quran-text-loaded");
                                _context3.next = 20;
                                break;
                              case 4:
                                if (navigator.onLine) {
                                  _context3.next = 14;
                                  break;
                                }
                                t = "<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>";
                                e = "<h4 onclick=\"window.location.href = '" + base_path + '/\';" style="cursor:pointer; color:#b00200">';
                                _context3.next = 9;
                                return '<div style="text-align:center;">' + t + "<h1>No Network Available</h1>" + e + "Reload Again</h4>" + t + "</div>";
                              case 9:
                                i = _context3.sent;
                                document.getElementById("offlineModetext").style.display = "block";
                                document.getElementById("offlineReloadtext").style.display = "none";
                                $("#preview").addClass("quran-text-loaded");
                                return _context3.abrupt("return", i);
                              case 14:
                                _context3.t0 = startAfterCallApi != startFromAyat;
                                if (!_context3.t0) {
                                  _context3.next = 20;
                                  break;
                                }
                                startAfterCallApi = startFromAyat;
                                endAfterCallApi = endOnAyat;
                                _context3.next = 20;
                                return $.ajax({
                                  headers: {
                                    "cache-control": "public, max-age=86400000",
                                    "Content-Type": "application/json"
                                  },
                                  url: local_server + "/api/getArabic/data/".concat(M, "/").concat(C, "/").concat(B, "/") + L,
                                  type: "GET",
                                  dataType: "json",
                                  cache: !0,
                                  success: function success(t) {
                                    a = t, W = !0, document.getElementById("offlineReloadtext").style.display = "none", $("#preview").addClass("quran-text-loaded");
                                  },
                                  error: function error(t, e, a) {
                                    console.log(a), document.getElementById("offlineReloadtext").style.display = "block", $("#preview").addClass("quran-text-loaded");
                                  }
                                });
                              case 20:
                              case "end":
                                return _context3.stop();
                            }
                          }, _callee3);
                        }));
                        return function (_x9) {
                          return _ref4.apply(this, arguments);
                        };
                      }());
                    case 3:
                      if (!i) {
                        _context4.next = 5;
                        break;
                      }
                      return _context4.abrupt("return", {
                        v: i
                      });
                    case 5:
                      if (!(null != r && "true" === r)) {
                        _context4.next = 24;
                        break;
                      }
                      _o = localStorage.getItem("transalationFontFamily" + s), _r = localStorage.getItem("isRtl" + s), _i = localStorage.getItem("scaleRatio" + s);
                      _context4.t0 = null != _o && null != _o || !navigator.onLine;
                      if (_context4.t0) {
                        _context4.next = 11;
                        break;
                      }
                      _context4.next = 11;
                      return fetch(base_path + "/cache/translationData/".concat(s, "/info.plist")).then(function (t) {
                        return t.text();
                      }).then(function (t) {
                        var t = new DOMParser().parseFromString(t, "text/xml").getElementsByTagName("string"),
                          e = t[1].innerHTML,
                          a = t[3].innerHTML,
                          n = t[4].innerHTML,
                          t = t[5].innerHTML;
                        _r = "0" === _r ? "start" : "end", localStorage.setItem("transalationFontFamily" + s, e), localStorage.setItem("isRtl" + s, a), localStorage.setItem("splitRatio" + s, n), localStorage.setItem("scaleRatio" + s, t), _o = e, _r = a, _i = t;
                      });
                    case 11:
                      _i = null != _i && null != _i || navigator.onLine ? .5 < _i ? 36 + .36 * (_i = 100 * (_i - .5)) : .5 + _i : "20px";
                      if (!(null != s)) {
                        _context4.next = 24;
                        break;
                      }
                      _n = "";
                      _context4.t1 = 1 != ayatRelations[u - 1][0] && 1 == ayatRelations[u - 1][4] && 9 != ayatRelations[u - 1][0];
                      if (!_context4.t1) {
                        _context4.next = 22;
                        break;
                      }
                      if (!(null !== (_n = localStorage.getItem(s + "Bismillah")) && void 0 !== _n || !navigator.onLine)) {
                        _context4.next = 20;
                        break;
                      }
                      _n = "";
                      _context4.next = 22;
                      break;
                    case 20:
                      _context4.next = 22;
                      return function (t) {
                        return new Promise(function (e, n) {
                          $.ajax({
                            url: base_path + "/cache/translationData/".concat(t, "/1.json"),
                            dataType: "json",
                            cache: !0,
                            success: function success(t) {
                              e(t);
                            },
                            error: function error(t, e, a) {
                              n("error");
                            },
                            complete: function complete() {}
                          });
                        });
                      }(s).then(function (t) {
                        _n = t.DATA;
                      });
                    case 22:
                      _context4.next = 24;
                      return function (o, r) {
                        return new Promise(function (a, n) {
                          localforage.getItem(r + o).then(function (t) {
                            var e;
                            null == t ? navigator.onLine ? ((null == surahNameList || surahNameList.length <= 0 && r) && dt(r).then(function (t) {
                              for (var e in surahNameList = [], t) surahNameList.push(t[e]);
                              localStorage.setItem(r + "-SuraName", JSON.stringify(surahNameList));
                            }), $.ajax({
                              url: base_path + "/cache/translationData/".concat(r, "/") + o + ".json",
                              dataType: "json",
                              cache: !0,
                              success: function success(t) {
                                var e = t.DATA;
                                1 == o && localStorage.setItem(r + "Bismillah", t.DATA), localforage.setItem(r + o, e).then(function (t) {
                                  a(t);
                                })["catch"](function (t) {
                                  console.log(t);
                                });
                              },
                              error: function error(t, e, a) {
                                n("error");
                              },
                              complete: function complete() {}
                            })) : a("No Network Available") : ((null == surahNameList || surahNameList.length <= 0) && (e = JSON.parse(localStorage.getItem(r + "-SuraName")), surahNameList = e), a(t));
                          })["catch"](function (t) {
                            console.log(t), n(t);
                          });
                        });
                      }(u, s).then(function (e) {
                        if (1 == ayatRelations[u - 1][4]) {
                          var a = ayatRelations[u][0] - 1;
                          var _t;
                          _t = null == surahNameList || surahNameList.length <= 0 ? "" : surahNameList[0][a], l = '<div class="translationText"' + "style=\"font-size: ".concat(_i + "px", ";zoom: ").concat(c, "; font-family : ").concat(_o, "; text-align : ").concat(_r, "; text-align-last : auto;\"") + "><br/>" + _t + "<p>" + _n + "<p/><p>" + e + "</p></div>";
                        } else l = '<p class="translationText"' + "style=\"font-size: ".concat(_i + "px", ";zoom: ").concat(c, "; font-family : ").concat(_o, "; text-align : ").concat(_r, "; text-align-last : auto;\"") + ">" + e + "</p>";
                      });
                    case 24:
                      g = "";
                      if (!(9 == selectionOfScriptNo)) {
                        _context4.next = 86;
                        break;
                      }
                      t = 0;
                    case 27:
                      if (!(t < totalAyaat.length)) {
                        _context4.next = 84;
                        break;
                      }
                      V = st = H ? a : a[u].DATA;
                      if (!(parseInt(d) < parseInt(totalAyaat[t]))) {
                        _context4.next = 81;
                        break;
                      }
                      try {
                        _ = V.replaceAll('height="117"', 'height="117"' + "style=\"zoom: ".concat(c, "; margin-left: ").concat(J, "\""));
                      } catch (t) {
                        console.log(t.message);
                      }
                      f = _;
                      1 == W && navigator.onLine && (Z = d.toString(), localforage.setItem(e + "" + Z, f).then(function (t) {})["catch"](function (t) {
                        console.log(t);
                      }));
                      G = (h = t + "-" + (T = parseInt(d) - parseInt(totalAyaat[t - 1]) + 1)) + "-T";
                      if (!(u < ayatRelations.length)) {
                        _context4.next = 67;
                        break;
                      }
                      if (!(1 == ayatRelations[u][8])) {
                        _context4.next = 66;
                        break;
                      }
                      Y = ht(ayatRelations[u - 1][1]), X = ht(ayatRelations[u - 1][8]);
                      if (!(1 == ayatRelations[u][2])) {
                        _context4.next = 53;
                        break;
                      }
                      p = 1;
                    case 39:
                      if (!(p < ayatRelations.length)) {
                        _context4.next = 51;
                        break;
                      }
                      if (!(1 == ayatRelations[p][8])) {
                        _context4.next = 48;
                        break;
                      }
                      if (!(m == ayatRelations[p][2])) {
                        _context4.next = 46;
                        break;
                      }
                      if (!(n++, u == p)) {
                        _context4.next = 44;
                        break;
                      }
                      return _context4.abrupt("break", 51);
                    case 44:
                      _context4.next = 48;
                      break;
                    case 46:
                      if (!(n = 0, m = ayatRelations[p][2], u == p)) {
                        _context4.next = 48;
                        break;
                      }
                      return _context4.abrupt("break", 51);
                    case 48:
                      p++;
                      _context4.next = 39;
                      break;
                    case 51:
                      _context4.next = 66;
                      break;
                    case 53:
                      p = 1;
                    case 54:
                      if (!(p < ayatRelations.length)) {
                        _context4.next = 66;
                        break;
                      }
                      if (!(1 == ayatRelations[p][8])) {
                        _context4.next = 63;
                        break;
                      }
                      if (!(m == ayatRelations[p][2])) {
                        _context4.next = 61;
                        break;
                      }
                      if (!(n++, u == p)) {
                        _context4.next = 59;
                        break;
                      }
                      return _context4.abrupt("break", 66);
                    case 59:
                      _context4.next = 63;
                      break;
                    case 61:
                      if (!(ayatRelations[p - 1][2] != ayatRelations[p][2] ? n++ : (n = 1, m = ayatRelations[p][2]), u == p)) {
                        _context4.next = 63;
                        break;
                      }
                      return _context4.abrupt("break", 66);
                    case 63:
                      p++;
                      _context4.next = 54;
                      break;
                    case 66:
                      16 == ayatRelations[u - 1][1] && 141 == ayatRelations[u - 1][4] && (n = 16), 114 == ayatRelations[u][0] && 6 == ayatRelations[u][4] && (Y = ht(1), X = ht(6), n = 39);
                    case 67:
                      Z = ht(n), K = juzmarkRelations.find(function (t) {
                        return t == u;
                      }), tt = sajdamarkRelations.find(function (t) {
                        return t == u;
                      }), y = rubamarkRelations.find(function (t) {
                        return t == u;
                      }), x = nisfmarkRelations.find(function (t) {
                        return t == u;
                      }), w = salasamarkRelations.find(function (t) {
                        return t == u;
                      }), k = '<div class="row maindiv" id=maindiv style="">', b = "</div>", v = '<div class="col-6 col-sm-6 col-md-6 col-lg-6 translatedivUrdu .pagebreak-translation qr0" style="" data-id=' + T + " id=" + G + ' ng-click="playAudio(' + T + ')">', S = "</div>", A = (D = null != y || null != x || null != w ? null != r && "true" === r ? '<div class="col-6 col-sm-6 col-md-6 col-lg-6 translatedivArabic .pagebreak-translation qr0" data-id=' + T + " id=" + h + ' ng-click="playAudio(' + T + ')">' : '<div class="qr0" data-id=' + T + " id=" + h + ' ng-click="playAudio(' + T + ')" style="padding-left:10px; margin-right:15px">' : null != r && "true" === r ? '<div class="col-6 col-sm-6 col-md-6 col-lg-6 translatedivArabic .pagebreak-translation qr0" style="" data-id=' + T + " id=" + h + ' ng-click="playAudio(' + T + ')">' : '<div class="qr0" data-id=' + T + " id=" + h + ' ng-click="playAudio(' + T + ')">', "</div>"), f = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="40" height="75" style="position:absolute; right:0;padding-left:10px; margin-right:2px">', R = " <text x='30' y='50' font-size='45' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0639    </text>\n            <text x='30' y='25' font-size='14' fill='#75962F' stroke='none'>\n            ".concat(Y, "\n            </text>\n            <text x='30' y='46' font-size='12' fill='#75962F' stroke='none'>\n            ").concat(X, "\n            </text>\n            <text x='30' y='70' font-size='14' fill='#75962F' stroke='none'>\n            ").concat(Z, "\n            </text>"), et = "</svg>", at = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="40" height="75" style="position:absolute; right:0">', nt = "<text transform='rotate(-90)' text-anchor='start' x='-10' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   السجدة</text>", ot = "</svg>", I = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="40" height="75" style="position:absolute; right:0">', rt = "<text transform='rotate(-90)' text-anchor='start' x='-25' y='30' font-size='28' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>ربع</text>", it = "<text transform='rotate(-90)' text-anchor='start' x='-25' y='30' font-size='28' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>نصف</text>", lt = "<text transform='rotate(-90)' text-anchor='start' x='-25' y='30' font-size='28' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>ثلاثة</text>", j = "</svg>";
                      if (!(null != K)) {
                        _context4.next = 76;
                        break;
                      }
                      N = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">', F = "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u06DE \u0627\u0644\u062C\u0632</text><text transform='rotate(-90)' text-anchor='start' x='-40' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(juzmarkRelations.findIndex(function (t) {
                        return t == K;
                      }) + 1), "</text>"), z = "</svg>";
                      if (!(null != r && "true" === r)) {
                        _context4.next = 74;
                        break;
                      }
                      N = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0; margin-right:10px">';
                      g = P = u < ayatRelations.length && (1 == ayatRelations[u][8] || 114 == ayatRelations[u][0] && 6 == ayatRelations[u][4]) ? N + F + z + k + D + _ + A + v + l + S + b + f + R + et : N + F + z + k + D + _ + A + v + l + S + b;
                      return _context4.abrupt("break", 84);
                    case 74:
                      g = P = u < ayatRelations.length && (1 == ayatRelations[u][8] || 114 == ayatRelations[u][0] && 6 == ayatRelations[u][4]) ? N + F + z + D + _ + A + f + R + et : N + F + z + D + _ + A;
                      return _context4.abrupt("break", 84);
                    case 76:
                      if (!(u < ayatRelations.length)) {
                        _context4.next = 79;
                        break;
                      }
                      P = 1 == ayatRelations[u][8] || 114 == ayatRelations[u][0] && 6 == ayatRelations[u][4] ? (null != tt && (f = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="40" height="75" style="position:absolute; right:0;padding-left:10px; margin-right:20px">'), null != r && "true" === r ? k + D + _ + A + v + l + S + b + f + R + et : D + _ + A + f + R + et) : null != r && "true" === r ? k + D + _ + A + v + l + S + b : D + _ + A, null != tt && (P = P + at + nt + ot), null != y ? P = (I = 1 == ayatRelations[u - 1][8] ? '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="40" height="75" style="position:absolute; right:0;padding-left:10px; margin-right:25px">' : I) + rt + j + P : null != x ? P = (I = 1 == ayatRelations[u - 1][8] ? '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="40" height="75" style="position:absolute; right:0;padding-left:10px; margin-right:25px">' : I) + it + j + P : null != w && (P = (I = 1 == ayatRelations[u - 1][8] ? '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="40" height="75" style="position:absolute; right:0;padding-left:10px; margin-right:25px">' : I) + lt + j + P), g = P;
                      return _context4.abrupt("break", 84);
                    case 79:
                      g = P = null != r && "true" === r ? k + D + _ + A + v + l + S + b : D + _ + A;
                      return _context4.abrupt("break", 84);
                    case 81:
                      t++;
                      _context4.next = 27;
                      break;
                    case 84:
                      _context4.next = 107;
                      break;
                    case 86:
                      t = 0;
                    case 87:
                      if (!(t < totalAyaat.length)) {
                        _context4.next = 107;
                        break;
                      }
                      ct = juzmarkRelationsUsmanic.find(function (t) {
                        return t == u;
                      }), O = hizbmarkRelations.find(function (t) {
                        return t == u;
                      }), y = rubamarkRelationsUsmanic.find(function (t) {
                        return t == u;
                      }), x = nisfmarkRelationsUsmanic.find(function (t) {
                        return t == u;
                      }), w = salasamarkRelationsUsmanic.find(function (t) {
                        return t == u;
                      }), tt = sajdamarkRelations.find(function (t) {
                        return t == u;
                      });
                      if (!(st = H ? a : a[u].DATA, parseInt(d) < parseInt(totalAyaat[t]))) {
                        _context4.next = 104;
                        break;
                      }
                      V = st;
                      try {
                        _ = V.replaceAll('height="127"', 'height="127"' + "style=\"zoom: ".concat(c, "; margin-left: ").concat(J, "; margin-bottom: -15px\""));
                      } catch (t) {
                        console.log(t.message);
                      }
                      1 == W && navigator.onLine && (ut = d.toString(), localforage.setItem(e + "" + ut, _).then(function (t) {})["catch"](function (t) {
                        console.log(t);
                      }));
                      k = '<div class="row maindiv" id=maindiv style="">', b = "</div>", v = '<div class="col-6 col-sm-6 col-md-6 col-lg-6 translatedivUrdu .pagebreak-translation qr0" style="" data-id=' + (T = parseInt(d) - parseInt(totalAyaat[t - 1]) + 1) + " id=" + (G = (h = t + "-" + T) + "-T") + ' ng-click="playAudio(' + T + ')">', S = "</div>", A = (D = null != r && "true" === r ? '<div class="col-6 col-sm-6 col-md-6 col-lg-6 translatedivArabic .pagebreak-translation qr0" style="" data-id=' + T + " id=" + h + ' ng-click="playAudio(' + T + ')">' : '<div class="qr0" data-id=' + T + " id=" + h + ' ng-click="playAudio(' + T + ')">', "</div>");
                      if (!(null != ct)) {
                        _context4.next = 101;
                        break;
                      }
                      N = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">', F = "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062C\u0632\u0621</text><text transform='rotate(-90)' text-anchor='start' x='-30' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(juzmarkRelationsUsmanic.findIndex(function (t) {
                        return t == ct;
                      }) + 1), "</text>"), z = "</svg>";
                      if (!(null != r && "true" === r)) {
                        _context4.next = 99;
                        break;
                      }
                      N = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0; margin-right:10px">', g = P = null != O ? '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(hizbmarkRelations.findIndex(function (t) {
                        return t == O;
                      }) + 1), "</text>") + "</svg>" + N + F + z + k + D + _ + A + v + l + S + b : N + F + z + k + D + _ + A + v + l + S + b;
                      return _context4.abrupt("break", 107);
                    case 99:
                      g = P = null != O ? '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="75" height="75" style="position:absolute; right:0; ">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(hizbmarkRelations.findIndex(function (t) {
                        return t == O;
                      }) + 1), "</text>") + "</svg>" + N + F + z + D + _ + A : N + F + z + D + _ + A;
                      return _context4.abrupt("break", 107);
                    case 101:
                      at = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="40" height="75" style="position:absolute; right:0">', nt = "<text transform='rotate(-90)' text-anchor='start' x='-10' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   السجدة</text>", ot = "</svg>", I = '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="65" height="75" style="position:absolute; right:0">', rt = "<text transform='rotate(-90)' text-anchor='start' x='-15' y='30' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>ربع</text>", it = "<text transform='rotate(-90)' text-anchor='start' x='0' y='30' font-size='26' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>النصف</text>", lt = "<text transform='rotate(-90)' text-anchor='start' x='0' y='30' font-size='22' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>ثلاثةأرباعِ</text>", j = "</svg>";
                      P = null != r && "true" === r ? null != O ? '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(hizbmarkRelations.findIndex(function (t) {
                        return t == O;
                      }) + 1), "</text>") + "</svg>" + k + D + _ + A + v + l + S + b : null != y ? I + rt + j + '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(rubamarkRelationsUsmanic.findIndex(function (t) {
                        return t == y;
                      }) + 1), "</text>") + "</svg>" + k + D + _ + A + v + l + S + b : null != x ? I + it + j + '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(nisfmarkRelationsUsmanic.findIndex(function (t) {
                        return t == x;
                      }) + 1), "</text>") + "</svg>" + k + D + _ + A + v + l + S + b : null != w ? I + lt + j + '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(salasamarkRelationsUsmanic.findIndex(function (t) {
                        return t == w;
                      }) + 1), "</text>") + "</svg>" + k + D + _ + A + v + l + S + b : k + D + _ + A + v + l + S + b : null != O ? '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(hizbmarkRelations.findIndex(function (t) {
                        return t == O;
                      }) + 1), "</text>") + "</svg>" + D + _ + A : null != y ? I + rt + j + '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(rubamarkRelationsUsmanic.findIndex(function (t) {
                        return t == y;
                      }) + 1), "</text>") + "</svg>" + D + _ + A : null != x ? I + it + j + '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(nisfmarkRelationsUsmanic.findIndex(function (t) {
                        return t == x;
                      }) + 1), "</text>") + "</svg>" + D + _ + A : null != w ? I + lt + j + '<svg xmlns=\'http://www.w3.org/2000/svg\' border=\'1\' width="50" height="75" style="position:absolute; right:0">' + "<text transform='rotate(-90)' text-anchor='start' x='0' y='40' font-size='24' font-family='PDMS_Saleem_QuranFont' fill='#75962F' stroke='none'>   \u0627\u0644\u062D\u0650\u0632\u06E1\u0628</text><text transform='rotate(-90)' text-anchor='start' x='-36' y='38' font-size='18' fill='#75962F' stroke='none'>".concat(ht(salasamarkRelationsUsmanic.findIndex(function (t) {
                        return t == w;
                      }) + 1), "</text>") + "</svg>" + D + _ + A : D + _ + A, g = P = null != tt ? P + at + nt + ot : P;
                      return _context4.abrupt("break", 107);
                    case 104:
                      t++;
                      _context4.next = 87;
                      break;
                    case 107:
                      Q += g;
                    case 108:
                    case "end":
                      return _context4.stop();
                  }
                }, _loop);
              });
              u = C;
            case 6:
              if (!(u <= B)) {
                _context5.next = 14;
                break;
              }
              return _context5.delegateYield(_loop(), "t0", 8);
            case 8:
              _ret = _context5.t0;
              if (!(_typeof(_ret) === "object")) {
                _context5.next = 11;
                break;
              }
              return _context5.abrupt("return", _ret.v);
            case 11:
              u++;
              _context5.next = 6;
              break;
            case 14:
              return _context5.abrupt("return", Q);
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee4);
      }));
      return function j(_x4, _x5, _x6, _x7, _x8) {
        return _ref3.apply(this, arguments);
      };
    }();
  var N = function N(t, e) {
      var a = new Object();
      return a.OFFSET = t, a.DATA = e, JSON.stringify(a);
    },
    F = function F(t, e) {
      var a = localStorage.getItem("transalatedView"),
        n = JSON.parse(localStorage.getItem("seletedQuranFont"));
      return null == n ? 1 == isArabicCountry ? ejs.render("\n          <div data-page=\"<%= dpage %>\" id=\"<%= id %>\" style=".concat(null != a && "true" === a ? "text-align:start;padding-right:16px" : "text-align:center;padding-right:16px", ">\n            <%- pageData %>\n              <div class= ").concat(null != a && "true" === a ? "translationpagebreak" : "pagebreak", ">\n                <%= pagebreakId %>\n              <a id=\"next\" href=\"").concat(base_path, "/page/<%= page %>\"></a>\n              </div>  \n          </div>\n      "), {
        dpage: t,
        id: "page" + t,
        page: t,
        pagebreakId: Number(t),
        pageData: e
      }) : ejs.render("\n          <div data-page=\"<%= dpage %>\" id=\"<%= id %>\" style=".concat(null != a && "true" === a ? "text-align:start;padding-right:16px" : "text-align:center;padding-right:16px", ">\n            <%- pageData %>\n              <div class= ").concat(null != a && "true" === a ? "translationpagebreak" : "pagebreak", ">\n                <%= pagebreakId %>\n              <a id=\"next\" href=\"").concat(base_path, "/page/<%= page %>\"></a>\n              </div>  \n          </div>\n      "), {
        dpage: t,
        id: "page" + t,
        page: t,
        pagebreakId: Number(t + 1),
        pageData: e
      }) : 9 == n[1] ? ejs.render("\n        <div data-page=\"<%= dpage %>\" id=\"<%= id %>\" style=".concat(null != a && "true" === a ? "text-align:start;padding-right:16px" : "text-align:center;padding-right:16px", ">\n          <%- pageData %>\n            <div class= ").concat(null != a && "true" === a ? "translationpagebreak" : "pagebreak", ">\n              <%= pagebreakId %>\n            <a id=\"next\" href=\"").concat(base_path, "/page/<%= page %>\"></a>\n            </div>  \n        </div>\n    "), {
        dpage: t,
        id: "page" + t,
        page: t,
        pagebreakId: Number(t + 1),
        pageData: e
      }) : ejs.render("\n        <div data-page=\"<%= dpage %>\" id=\"<%= id %>\" style=".concat(null != a && "true" === a ? "text-align:start;padding-right:16px" : "text-align:center;padding-right:16px", ">\n          <%- pageData %>\n            <div class= ").concat(null != a && "true" === a ? "translationpagebreak" : "pagebreak", ">\n              <%= pagebreakId %>\n            <a id=\"next\" href=\"").concat(base_path, "/page/<%= page %>\"></a>\n            </div>  \n        </div>\n    "), {
        dpage: t,
        id: "page" + t,
        page: t,
        pagebreakId: Number(t),
        pageData: e
      });
    };
  var z = function z(t, e, a) {
    k(a);
  };
  function _() {
    var t,
      e = totalAyaat[n - 1],
      a = ayatRelations[e - 1];
    return o ? o > a[4] ? (t = o - a[4], ((t = ayatRelations[t + e - 1]) && t[0] == n ? t : ayatRelations[e - 1])[selectionOfScriptNo]) : o == a[4] ? a[selectionOfScriptNo] : void 0 : o < a[4] ? a[selectionOfScriptNo] : void 0;
  }
  return {
    juzmarkwithAyatrelationUsmanic: ft,
    juzmarkwithAyatrelation: gt,
    pageRelationsWithAyatsArray: u,
    pageRelationsWithAyats: function pageRelationsWithAyats() {
      ayatRelations = [], $.ajax({
        url: base_path + "/JSONFiles/ayatRelations.json",
        dataType: "json",
        cache: !0,
        success: function success(t) {
          for (n in t.ayatRelation) ayatRelations.push(t.ayatRelation[n]);
          for (var e = [], a = [], n = 0; n < ayatRelations.length; n++) for (var o = 0; o <= 610; o++) ayatRelations[n][9] === o && (e.push(ayatRelations[n][9]), e.push(n + 1), a.push(e), e = [], 0);
          for (var r, i = 1, l = 1, s = [], c = [], n = 0; n < a.length; n++) a[n][0] !== i && (r = a[n - 1][1], s.push(i), s.push(l), s.push(r), c.push(s), s = [], i += 1, l = a[n][1]);
        },
        error: function error(t, e, a) {
          console.log("ayat b " + t + " " + e.Mess + " " + a);
        },
        complete: function complete() {
          console.log("ayat c");
        }
      });
    },
    applyPages: d,
    goToDefinedPage: k,
    toogleIsScrolling: function toogleIsScrolling() {
      (scrollAllowed = !scrollAllowed) && v();
    },
    forceCheckContent: v,
    checkArabicContents: S,
    getMorePages: A,
    isMorePagesNeeded: R,
    getParahJuzzNames: function getParahJuzzNames() {
      return new Promise(function (e, n) {
        localforage.getItem("getParahJuzzNames").then(function (t) {
          null === t ? $.ajax({
            url: base_path + "/JSONFiles/parahNames.json",
            dataType: "json",
            cache: !0,
            success: function success(t) {
              localforage.setItem("getParahJuzzNames", t).then(function (t) {
                e(t);
              })["catch"](function (t) {
                console.log(t), n(t);
              });
            },
            error: function error(t, e, a) {
              n("error");
            },
            complete: function complete() {}
          }) : e(t);
        })["catch"](function (t) {
          console.log(t), n(t);
        });
      });
    },
    getSurahNames: function getSurahNames() {
      $.ajax({
        url: base_path + "/JSONFiles/surahNames.json",
        dataType: "json",
        cache: !0,
        success: function success(t) {
          t.SurahArabicNames;
          for (var e = [], a = t.SurahEnglishNames, n = 0; n <= a.length - 1; n++) e.push({
            name: a[n],
            number: n + 1
          });
        },
        error: function error(t, e, a) {
          console.log("read 2 " + t + " " + e.Mess + " " + a);
        },
        complete: function complete() {}
      });
    },
    getPageRelation: function () {
      var _getPageRelation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return $.ajax({
                url: base_path + "/JSONFiles/pageRelation.json",
                dataType: "json",
                cache: !0,
                success: function success(t) {
                  e[selectionOfScriptNo] = t["pageRelation" + selectionOfScript];
                },
                error: function error(t, e, a) {
                  console.log("read 2 " + t + " " + e.Mess + " " + a);
                },
                complete: function complete() {}
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee5);
      }));
      function getPageRelation(_x10) {
        return _getPageRelation.apply(this, arguments);
      }
      return getPageRelation;
    }(),
    getRukuSurahRelation: function getRukuSurahRelation() {
      $.ajax({
        url: base_path + "/JSONFiles/rukuSurahRelation.json",
        dataType: "json",
        cache: !0,
        success: function success(t) {},
        error: function error(t, e, a) {
          console.log("read 2 " + t + " " + e.Mess + " " + a);
        },
        complete: function complete() {}
      });
    },
    getSurahNumberFromPageNo: function getSurahNumberFromPageNo(t) {
      return a[selectionOfScriptNo][t - 1][0];
    },
    getParahNumberFromPageNo: function getParahNumberFromPageNo(t) {
      return a[selectionOfScriptNo][t - 1][2];
    },
    getPageData: I,
    getPages: j,
    createPageJSON: N,
    createPage: F,
    setxml: function setxml(t) {
      var e,
        a = location.href;
      a.includes("page") ? (e = a.split("page")[1].split("/")[1], $.ajax({
        url: "/page/${id}",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        },
        type: "post",
        dataType: "json",
        cache: !0
      }).done( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(t) {
          return _regeneratorRuntime().wrap(function _callee6$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                k(e);
              case 1:
              case "end":
                return _context7.stop();
            }
          }, _callee6);
        }));
        return function (_x11) {
          return _ref5.apply(this, arguments);
        };
      }()).fail(function (t) {
        console.log("Could not read xml from the backend " + t), console.log(t);
      })) : $.ajax({
        url: "/",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        },
        type: "post",
        dataType: "json",
        cache: !0
      }).done( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(t) {
          return _regeneratorRuntime().wrap(function _callee7$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                k(1);
              case 1:
              case "end":
                return _context8.stop();
            }
          }, _callee7);
        }));
        return function (_x12) {
          return _ref6.apply(this, arguments);
        };
      }()).fail(function (t) {
        console.log("Could not read xml from the backend " + t), console.log(t);
      });
    },
    goToDefinedPageMain: z,
    goToSurah: function goToSurah(t, e) {
      n = parseInt(t), o = e ? parseInt(e) : 1, z(0, 0, _());
    },
    searchPageForSurah: _,
    leadingZeros: function leadingZeros(t, e) {
      return (new Array(e + 1).join("0") + t).slice(-e);
    },
    pathToAyat: function pathToAyat(t, e) {
      return base_path + "/cache/" + e + "/" + t + ".json";
    },
    pathToEnglishAyat: function () {
      var _pathToEnglishAyat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(t) {
        return _regeneratorRuntime().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", base_path + "/cache/translationData/English-Pickthal/" + t + ".json");
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee8);
      }));
      function pathToEnglishAyat(_x13) {
        return _pathToEnglishAyat.apply(this, arguments);
      }
      return pathToEnglishAyat;
    }(),
    getAyatRelations: function getAyatRelations() {
      return new Promise(function (e, n) {
        localforage.getItem("ayatRelations").then(function (t) {
          null === t ? $.ajax({
            url: base_path + "/JSONFiles/ayatRelations.json",
            dataType: "json",
            cache: !0,
            success: function success(t) {
              localforage.setItem("ayatRelations", t.ayatRelation).then(function (t) {
                e(t);
              })["catch"](function (t) {
                console.log(t), n(t);
              });
            },
            error: function error(t, e, a) {
              n("error"), console.log("pageRelationsWithAyats 2 " + t + " " + e.Mess + " " + a);
            },
            complete: function complete() {}
          }) : e(t);
        })["catch"](function (t) {
          console.log(t), n(t);
        });
      });
    }
  };
}();
$(window).on("load", function () {
  localforage.getItem("firebaseUser").then(function (t) {
    t && (userId = t, getUserBookmarksOnLoad(t).then(function (t) {
      userBookmarks = t;
    }));
  })["catch"](function (t) {
    console.log(t);
  });
  var t = document.createElement("div"),
    t = (t.setAttribute("id", "addBookmarkDialog"), t.setAttribute("style", "display: none;"), t.setAttribute("align", "center"), t.innerHTML = '<form method="dialog"> <div class="dialog-body"> <input type="text" ayatId="" name="newBookId" id="newBookId" value="" /> </div> </form> <div id="addBookmark_req" class="addBookmark_req" style="display:none;"><p style="color: red; text-align:left; margin-bottom: 0 !important;">Required*</p></div>', document.body.appendChild(t), document.createElement("div")),
    t = (t.setAttribute("id", "removeBookmarkDialog"), t.setAttribute("style", "display: none;"), t.setAttribute("align", "center"), t.innerHTML = '<h4>Are you sure you want to delete the Bookmark</h4> <form method="dialog"> <div class="dialog-body"><p id="removeBookmarkName"></p></div> </form>', document.body.appendChild(t), document.createElement("div")),
    a = (t.setAttribute("id", "snackbar"), document.body.appendChild(t), $("#b_juz").click(function (t) {}), localforage.getItem("reciterName").then(function (t) {
      null == t ? $(".b_reciter").text("Mishari-Rashid-HQ") : $(".b_reciter").text(t);
    }), new XMLHttpRequest());
  a.open("GET", backend_url_local + "/checkSession"), a.responseType = "json", a.withCredentials = !0, a.send(), a.onload = function () {
    var e = a.response;
    null !== e.uid && void 0 !== e.uid ? localforage.setItem("firebaseUser", e.uid).then(function (t) {
      userId = e.uid;
    })["catch"](function (t) {
      console.log(t);
    }) : firebase.auth().signOut().then(function (t) {});
  };
});
var page,
  previousPage,
  previousPageAyat,
  pageAyat,
  lastVisitedPage = localStorage.getItem("page"),
  newpage = parseInt(lastVisitedPage),
  lastVisitedPageAyat = localStorage.getItem("pageAyat"),
  currentHash = "#/page/1",
  ayatRelations = [],
  animatedScroll = !0;
var scrollCount = 0;
var previousSura,
  previousJuzPara,
  lastAnimatedScroll = !1,
  scroll = 0,
  version = 15;
var globalTypeOfRequest,
  highlightPageNo,
  highlightJuzNo,
  onLoad = !0,
  SuraNamesUrl = ["al-fatiha", "al-baqara", "al-e-imran", "an-nisa", "al-maeda", "al-anaam", "al-araf", "al-anfal", "al-tawba", "yunus", "hud", "yusuf", "al-rad", "ibrahim", "al-hijr", "an-nahl", "al-isra", "al-kahf", "maryam", "ta-ha", "al-anbiya", "al-hajj", "al-mumenoon", "al-noor", "al-furqan", "al-shuara", "al-naml", "al-qasas", "al-ankaboot", "al-room", "luqman", "as-sajda", "al-ahzab", "saba", "fatir", "ya-seen", "as-saaffat", "sad", "az-zumar", "ghafir", "fussilat", "ash-shura", "az-zukhruf", "ad-dukhan", "al-jathiya", "al-ahqaf", "muhammad", "al-fath", "al-hujraat", "qaf", "adh-dhariyat", "at-tur", "an-najm", "al-qamar", "ar-rahman", "al-waqia", "al-hadid", "al-mujadila", "al-hashr", "al-mumtahina", "as-saff", "al-jumua", "al-munafiqoon", "at-taghabun", "at-talaq", "at-tahrim", "al-mulk", "al-qalam", "al-haaqqa", "al-maarij", "nooh", "al-jinn", "al-muzzammil", "al-muddaththir", "al-qiyama", "al-insan", "al-mursalat", "an-naba", "an-naziat", "abasa", "at-takwir", "al-infitar", "al-mutaffifin", "al-inshiqaq", "al-burooj", "at-tariq", "al-ala", "al-ghashiya", "al-fajr", "al-balad", "ash-shams", "al-lail", "ad-dhuha", "al-inshirah", "at-tin", "al-alaq", "al-qadr", "al-bayyina", "al-zalzala", "al-adiyat", "al-qaria", "at-takathur", "al-asr", "al-humaza", "al-fil", "quraish", "al-maun", "al-kauther", "al-kafiroon", "an-nasr", "al-masadd", "al-ikhlas", "al-falaq", "an-nas"];
function UpdatedPlistResource() {
  return _UpdatedPlistResource.apply(this, arguments);
}
function _UpdatedPlistResource() {
  _UpdatedPlistResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    return _regeneratorRuntime().wrap(function _callee12$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return $.ajax({
            url: local_server + "/api/download/updatedResourcePlist",
            type: "POST",
            cache: !0,
            success: function success(a) {
              0 != a && (localforage.removeItem("translationList").then(function () {
                console.log("translationList key is cleared!");
              })["catch"](function (a) {
                console.log(a);
              }), localforage.removeItem("reciterList").then(function () {
                console.log("reciterList key is cleared!");
              })["catch"](function (a) {
                console.log(a);
              }));
            },
            error: function error(a, e, t) {
              console.log(t);
            },
            complete: function complete() {}
          });
        case 2:
        case "end":
          return _context13.stop();
      }
    }, _callee12);
  }));
  return _UpdatedPlistResource.apply(this, arguments);
}
function quranView() {
  if (1 < scrollCount && !animatedScroll && (lastAnimatedScroll = animatedScroll, animatedScroll = $("html, body").is(":animated")), $("[data-page]:in-viewport").data("page")) {
    null == (newpage = $("[data-page]:in-viewport").data("page")) && (page = 1), 1 == newpage ? page = 1 : 1 < newpage && (page = newpage), 1 < scrollCount && !animatedScroll && (pageAyat = (pageAyat = $("[data-id]:in-viewport").attr("id")) && pageAyat.split("-")[0] + "-" + (parseInt(pageAyat.split("-")[1]) + 1));
    var o,
      t = "1-1",
      e = (highlightSuraNo ? (highlightAyaNo ? (t = highlightSuraNo + "-" + highlightAyaNo, getSurahNamesPromise().then(function (a) {
        a.SurahEnglishNames[highlightSuraNo - 1];
        localforage.setItem("selectedSuraId", o).then(function (a) {})["catch"](function (a) {});
      })) : t = highlightSuraNo + "-1", $("#" + t).addClass("qr0_active"), $("#" + t + "-T").addClass("qr0_active"), scrollSelections.getAyatRelations().then(function (a) {
        var e,
          t = totalAyaat[highlightSuraNo - 1];
        var l = a[t - 1];
        highlightAyaNo > l[4] && (e = highlightAyaNo - l[4], !(l = a[t + e - 1]) || highlightSuraNo != l[0]) && (l = a[t - 1], highlightAyaNo = l[4]), localforage.setItem("surah_ruku_url_audio", padLeadingZeros(l[0], 3) + "-" + padLeadingZeros(l[1], 2)), localforage.setItem("ayaah_in_surah", l[4]), localforage.setItem("ayaah_ruku_url_audio", l[8]);
      }), onLoad = !1) : highlightPageNo ? localforage.getItem("pageRelations").then(function (a) {
        var e;
        highlightAyaNo = (location.href.includes("uthmanic") || 5 == localStorage.getItem("quranfontSelectedOption") ? (e = a.pageRelationUthmanic, highlightSuraNo = e[highlightPageNo - 1][0], e) : (e = a.pageRelationIndoPak, highlightSuraNo = e[highlightPageNo - 1][0], e))[highlightPageNo - 1][4], t = highlightSuraNo + "-" + highlightAyaNo, getSurahNamesPromise().then(function (a) {
          a.SurahEnglishNames[highlightSuraNo - 1];
          localforage.setItem("selectedSuraId", o).then(function (a) {})["catch"](function (a) {});
        }), $("#" + t).addClass("qr0_active"), $("#" + t + "-T").addClass("qr0_active"), onLoad = !1;
      }) : highlightJuzNo ? onLoad = !1 : localforage.getItem("surah_ruku_url_audio").then(function (e) {
        localforage.getItem("ayaah_in_surah").then(function (a) {
          null != e && null != a && null != e && null != a && (t = e.slice(0, 3).replace(/^0+/, "") + "-" + a), getSurahNamesPromise().then(function (a) {
            a.SurahEnglishNames[e.slice(0, 3).replace(/^0+/, "") - 1];
            localforage.setItem("selectedSuraId", o).then(function (a) {})["catch"](function (a) {});
          }), $("#" + t).addClass("qr0_active"), $("#" + t + "-T").addClass("qr0_active"), sharingQuranViewSura = t;
        });
      }), 0 < suraButtonClick && (suraButtonClick -= 1), $("[data-id]:in-viewport")[0]);
    if (e && (o = e.getAttribute("id").split("-")[0]), highlightSuraNo && onLoad && (o = highlightSuraNo), highlightJuzNo && onLoad && paraRelationsPromise().then(function (a) {
      o = a[highlightJuzNo - 1][0];
    }), previousSura != o && 0 == suraButtonClick && getSurahNamesPromise().then(function (a) {
      a = a.SurahEnglishNames[o - 1];
      sharingQuranViewSuraName = a, $(".b_sura").text(a), previousSura = o, localforage.setItem("selectedSuraId", o).then(function (a) {})["catch"](function (a) {});
    }), void 0 !== page) if (currentHash = "#/page/" + page, previousPage != page && ($("#info").text("Page " + page), previousPage = page, pageRelationsPromise().then(function (a) {
      for (var e, t = "IndoPak" == currentScript ? a.pageRelationIndoPak : a.pageRelationUthmanic, l = 0; l < t.length; l++) {
        var i = !1;
        if (t[l][selectionOfScriptNo] === parseInt(page) && (previousSelectedSura = o, o = t[l][0], e = "IndoPak" == currentScript ? (previousJuz = e, t[l][3]) : t[l][2], i = !0), 1 == i) {
          previousJuzPara != e && scrollSelections.getParahJuzzNames().then(function (a) {
            a = "IndoPak" == currentScript ? a.ParaName : a.JuzName;
            a[e - 1];
            61 == page && (e = 4), 441 == page && (e = 23), $(".b_juz").text("Juz " + e), previousJuzPara = e, localforage.setItem("selectedJuzId", e).then(function (a) {})["catch"](function (a) {});
          });
          break;
        }
      }
    })), 2 < scrollCount && !animatedScroll) {
      if (scroll += 1, lastVisitedPageAyat != pageAyat) {
        previousPageAyat = pageAyat;
        e = document.getElementById(pageAyat);
        if (e) {
          var a;
          e = (a = ("true" === istranslation || !0 === istranslation ? e.parentElement : e).parentElement).attributes[0].value;
          newpage = e, localStorage.setItem("pageAyat", pageAyat), localStorage.setItem("page", e);
        }
      }
    } else animatedScroll = !1, scrollCount += 1;
  }
}
$(document).ready(function () {
  var a = Number(localStorage.getItem("LastModifyTimeForResourcePlist")),
    e = Date.parse(new Date());
  (!a || 864e5 < e - a) && (localStorage.setItem("LastModifyTimeForResourcePlist", e), UpdatedPlistResource());
}), $(window).scroll(function (a) {
  quranView();
}).scroll(), $(window).resize(function () {
  quranView();
});
var startScript = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return scrollSelections.getParahJuzzNames();
        case 2:
          _context12.next = 4;
          return localforage.getItem("surah_ruku_url_audio").then(function (a) {
            function e(a, e) {
              for (var t = a + ""; t.length < e;) t = "0" + t;
              return t;
            }
            null === a && localforage.setItem("surah_ruku_url_audio", e(1, 3) + "-" + e(1, 2)).then(function (a) {});
          });
        case 4:
          _context12.next = 6;
          return localforage.getItem("ayaah_ruku_url_audio").then(function (a) {
            null === a && localforage.setItem("ayaah_ruku_url_audio", 1).then(function (a) {});
          });
        case 6:
          _context12.next = 8;
          return localforage.getItem("ayaah_in_surah").then(function (a) {
            null === a && localforage.setItem("ayaah_in_surah", 1).then(function (a) {});
          });
        case 8:
          _context12.next = 10;
          return localforage.getItem("ruko_no").then(function (a) {
            null === a && localforage.setItem("ruko_no", 1).then(function (a) {});
          });
        case 10:
          _context12.next = 12;
          return scrollSelections.getAyatRelations().then( /*#__PURE__*/function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(t) {
              var l, i, a, e, o, r, n, s, h;
              return _regeneratorRuntime().wrap(function _callee10$(_context11) {
                while (1) switch (_context11.prev = _context11.next) {
                  case 0:
                    ayatRelations = t;
                    i = qmAppUrl();
                    if (!(-1 !== i.indexOf("?"))) {
                      _context11.next = 6;
                      break;
                    }
                    (l = i.split("?")[1].split("=")[0]) && "suraAya" === l && getShareAyaData().then(function (a) {
                      var e = a.split("|")[1],
                        a = (a.split("|")[0], JSON.parse("[" + e + "]")[9]);
                      scrollSelections.goToDefinedPage(a);
                    });
                    _context11.next = 47;
                    break;
                  case 6:
                    if (!(l = i.split("/")[3], t = i.split("/")[4], ["en", "eng", "english", "ur", "urd", "urdu"].includes(l) && (h = "ur" == (globalTypeOfRequest = l) || "urd" == globalTypeOfRequest || "urdu" == globalTypeOfRequest ? (Cookies.set("languageoption", globalTypeOfRequest, {
                      expires: 300
                    }), {
                      id: "Urdu-AhmedAli"
                    }) : (Cookies.set("languageoption", globalTypeOfRequest, {
                      expires: 300
                    }), {
                      id: "English-Pickthal"
                    }), forTranslationUrl(h), l = i.split("/")[4], t = i.split("/")[5]), l)) {
                      _context11.next = 46;
                      break;
                    }
                    if (!/[a-zA-Z]/.test(l)) {
                      _context11.next = 43;
                      break;
                    }
                    o = parseInt(l);
                    if (!(0 < o)) {
                      _context11.next = 13;
                      break;
                    }
                    scrollSelections.goToSurah(o);
                    _context11.next = 41;
                    break;
                  case 13:
                    o = l.toLowerCase();
                    _context11.t0 = (a = l, SuraNamesUrl.includes(o) && (a = "surannames", o = SuraNamesUrl.indexOf(l), e = -1 !== o ? o + 1 : 1), a);
                    _context11.next = _context11.t0 === "page" ? 17 : _context11.t0 === "uthmanic" ? 20 : _context11.t0 === "translation" ? 24 : _context11.t0 === "surannames" ? 27 : _context11.t0 === "sura" ? 29 : _context11.t0 === "surah" ? 31 : _context11.t0 === "para" ? 34 : _context11.t0 === "juz" ? 37 : 40;
                    break;
                  case 17:
                    r = JSON.parse(localStorage.getItem("seletedQuranFont")), n = i.split("page")[1].split("/")[1];
                    isUthmanicReader() ? goToIndoPakPageStart(n) : (null != r && 9 != r[1] || (n = parseInt(n) - 1), n = Number(n), highlightPageNo = n < 1 ? n = 1 : 610 < n ? n = 610 : n, scrollSelections.goToDefinedPageMain("/page/${id}", "get", n));
                    return _context11.abrupt("break", 41);
                  case 20:
                    n = i.split("page")[1].split("/")[1];
                    localStorage.setItem("quranfontSelectedOption", 5);
                    localStorage.setItem("seletedQuranFont", JSON.stringify(["Uthmanic", 5, "dataUsmani"])), n = Number(n), highlightPageNo = n < 1 ? n = 1 : 610 < n ? n = 610 : n, scrollSelections.goToDefinedPageMain("/page/${id}", "get", n);
                    return _context11.abrupt("break", 41);
                  case 24:
                    s = i.split("translation")[1].split("/")[1].toLowerCase(), h = "urdu" == s || "urdu-ahmedali" == s ? (console.log("Urdu"), {
                      id: "Urdu-AhmedAli"
                    }) : (console.log("English"), {
                      id: "English-Pickthal"
                    }), r = (forTranslationUrl(h), JSON.parse(localStorage.getItem("seletedQuranFont"))), n = i.split("page")[1].split("/")[1];
                    isUthmanicReader() ? goToIndoPakPageStart(n) : (null != r && 9 != r[1] || (n = parseInt(n) - 1), n = Number(n), highlightPageNo = n < 1 ? n = 1 : 610 < n ? n = 610 : n, scrollSelections.goToDefinedPageMain("/page/${id}", "get", n));
                    return _context11.abrupt("break", 41);
                  case 27:
                    highlightSuraNo = e, highlightAyaNo = 1, suraClickedCheck, suraClickedNo = highlightSuraNo, scrollSelections.goToSurah(highlightSuraNo, highlightAyaNo);
                    return _context11.abrupt("break", 41);
                  case 29:
                    (n = i.split("sura")[1].split("/"))[1] = parseInt(n[1]), n[3] = parseInt(n[3]), highlightSuraNo = n[1] < 1 ? n[1] = 1 : 114 < n[1] ? n[1] = 114 : n[1], highlightAyaNo = n[3], suraClickedCheck, suraClickedNo = highlightSuraNo, scrollSelections.goToSurah(highlightSuraNo, highlightAyaNo);
                    return _context11.abrupt("break", 41);
                  case 31:
                    n = i.split("surah")[1].split("/")[1];
                    n = Number(n), highlightSuraNo = n[1] < 1 ? n = 1 : 114 < n ? n = 114 : n, highlightSuraNo = n[1] < 1 ? n = 1 : 114 < n ? n = 114 : n, suraClickedCheck, suraClickedNo = highlightSuraNo, scrollSelections.goToSurah(n);
                    return _context11.abrupt("break", 41);
                  case 34:
                    n = i.split("para")[1].split("/")[1];
                    highlightJuzNo = n < 1 ? n = 1 : 30 < n ? n = 30 : n, juzClicked(n);
                    return _context11.abrupt("break", 41);
                  case 37:
                    n = i.split("juz")[1].split("/")[1];
                    highlightJuzNo = n < 1 ? n = 1 : 30 < n ? n = 30 : n, juzClicked(n);
                    return _context11.abrupt("break", 41);
                  case 40:
                    scrollSelections.goToDefinedPageMain("/", "get", lastVisitedPage);
                  case 41:
                    _context11.next = 44;
                    break;
                  case 43:
                    l.includes("-") && /[0-9]/.test(l) ? (o = l.split("-"), highlightSuraNo = parseInt(o[0]), highlightAyaNo = parseInt(o[1]), suraClickedCheck, suraClickedNo = highlightSuraNo, scrollSelections.goToSurah(highlightSuraNo, highlightAyaNo)) : /[0-9]/.test(l) && (highlightSuraNo = parseInt(l), highlightAyaNo = parseInt(t), suraClickedCheck, suraClickedNo = highlightSuraNo, scrollSelections.goToSurah(highlightSuraNo, highlightAyaNo));
                  case 44:
                    _context11.next = 47;
                    break;
                  case 46:
                    suraClickedCheck, scrollSelections.goToDefinedPageMain("/", "get", lastVisitedPage);
                  case 47:
                  case "end":
                    return _context11.stop();
                }
              }, _callee10);
            }));
            return function (_x14) {
              return _ref8.apply(this, arguments);
            };
          }());
        case 12:
        case "end":
          return _context12.stop();
      }
    }, _callee11);
  }));
  return function startScript() {
    return _ref7.apply(this, arguments);
  };
}();
function isUthmanicReader() {
  var a = JSON.parse(localStorage.getItem("seletedQuranFont"));
  return null == a ? 1 == isArabicCountry : 5 == a[1];
}
function goToIndoPakPageStart(e) {
  e = Math.min(Math.max(parseInt(e) || 2, 2), 611), pageRelationsPromise().then(function (a) {
    a = a.pageRelationIndoPak[e - 2];
    highlightSuraNo = a[0], highlightAyaNo = a[4], suraClickedNo = highlightSuraNo, scrollSelections.goToSurah(highlightSuraNo, highlightAyaNo);
  });
}
document.addEventListener("DOMContentLoaded", function () {
  startScript();
});
function toolbarshow() {
  var t = document.getElementById("toolbar-up-Btn"),
    e = document.getElementById("toolbar-down-Btn"),
    n = document.getElementById("inc-dec"),
    d = document.getElementById("help-div"),
    o = document.getElementById("bottom-bar-downLoad-button"),
    l = window.matchMedia("(max-width: 992px)");
  window.matchMedia("(min-width: 768px) and (max-width: 992px) and (orientation: landscape)");
  l.matches ? o.style.display = "none" : o.style.display = "initial", t.style.display = "none", e.style.display = "block", n.style.display = "block", d.style.display = "block";
}
function toolbarhide() {
  var t = document.getElementById("toolbar-up-Btn"),
    e = document.getElementById("toolbar-down-Btn"),
    n = document.getElementById("inc-dec"),
    d = document.getElementById("help-div"),
    o = document.getElementById("bottom-bar-downLoad-button");
  t.style.display = "block", e.style.display = "none", n.style.display = "none", d.style.display = "none", o.style.display = "none";
}
$(".reciter-modal").on("click", function (e) {
  e.preventDefault(), $("#reciterModal").modal("show").find(".modal-content").load($(this).attr("href"));
}), document.getElementById("b_sura").addEventListener("click", function () {
  var e = document.createElement("script");
  e.src = modalUrl + "/models/models-js/sura/sura.js?v=" + app_version, document.body.appendChild(e);
}), document.getElementById("b_juz").addEventListener("click", function () {
  var e = document.createElement("script");
  e.src = modalUrl + "/models/models-js/juz/juz.js?v=" + app_version, document.body.appendChild(e);
});
function getShareAyaData() {
  var s,
    i = [];
  return new Promise(function (r, a) {
    var e, n;
    -1 !== suraAyaURL.indexOf("-") ? (e = suraAyaURL.split("-")[0], n = suraAyaURL.split("-")[1], scrollSelections.getAyatRelations().then(function (a) {
      for (var t = 0; t < a.length; t++) if (a[t][0] === parseInt(e) && a[t][4] === parseInt(n)) {
        s = t + 1, i = a[t];
        break;
      }
      r(s + "|" + i);
    })) : a("suraAya splitter not found");
  });
}
$(document).on("click", ".qr0", function () {
  var n, i, a, r;
  $("#btmEmptyBookmark-Btn").css("display", "inline"), $("#btmBookmark-Btn").css("display", "none"), $("#btmEmptyReadingBookmark-Btn").css("display", "inline"), $("#btmReadingBookmark-Btn").css("display", "none"), isPlaying || (window.history.replaceState(null, document.title, base_path + "/"), n = $(this).attr("data-id"), i = $(this).attr("id"), a = dataIdID = i, new Promise(function (e, t) {
    var s, i;
    -1 !== a.indexOf("-") ? (s = a.split("-")[0], i = a.split("-")[1], scrollSelections.getAyatRelations().then(function (t) {
      for (var a = 0; a < t.length; a++) if (t[a][0] === parseInt(s) && t[a][4] === parseInt(i)) {
        var _n2 = function _n2(t, a) {
          for (var n = t + ""; n.length < a;) n = "0" + n;
          return n;
        };
        localforage.setItem("surah_ruku_url_audio", _n2(t[a][0], 3) + "-" + _n2(t[a][1], 2)).then(function (t) {})["catch"](function (t) {
          console.log(t);
        }), localforage.setItem("ayaah_ruku_url_audio", t[a][8]).then(function (t) {})["catch"](function (t) {
          console.log(t);
        }), localforage.setItem("ayaah_in_surah", t[a][4]).then(function (t) {})["catch"](function (t) {
          console.log(t);
        }), localforage.setItem("ruko_no", t[a][1]).then(function (t) {}), r = a + 1;
        break;
      }
      e(r);
    })) : t("suraAya splitter not found");
  }).then(function (a) {
    var t;
    localforage.getItem("firebaseUser").then(function (t) {
      t && bookmarkString && (t = bookmarkString.split("|")[0], bookmarkString.split("|")[1].split(",").includes(a.toString()) && ($("#btmEmptyBookmark-Btn").css("display", "none"), $("#btmBookmark-Btn").css("display", "inline")), parseInt(a) === parseInt(t)) && ($("#btmEmptyReadingBookmark-Btn").css("display", "none"), $("#btmReadingBookmark-Btn").css("display", "inline"));
    })["catch"](function (t) {
      console.log(t);
    }), dataId = n, $(".qr0").removeClass("qr0_active"), lastId = (highlightAyaNo = "0" === lastId ? (i.includes("-T") && (i = (i = i.split("-T"))[0]), $("#" + i).addClass("qr0_active"), $("#" + i + "-T").addClass("qr0_active"), t = i.split("-"), highlightSuraNo = parseInt(t[0]), parseInt(t[1])) : (i.includes("-T") && (i = (i = i.split("-T"))[0]), $("#" + lastId).removeClass("qr0_active"), $("#" + i).addClass("qr0_active"), $("#" + i + "-T").addClass("qr0_active"), t = i.split("-"), highlightSuraNo = parseInt(t[0]), parseInt(t[1])), i), sharingSura = i, scrollSelections.getAyatRelations().then(function (t) {
      for (var a, n = i.split("-")[0], e = i.split("-")[1], s = 0; s < t.length; s++) if (t[s][0] === parseInt(n) && t[s][4] === parseInt(e)) {
        a = "IndoPak" == currentScript ? t[s][3] : t[s][2], previousSura != n ? getSurahNamesPromise().then(function (t) {
          t = t.SurahEnglishNames[n - 1];
          sharingQuranViewSuraName = t, $(".b_sura").text(t), previousSura = n;
        }) : getSurahNamesPromise().then(function (t) {
          sharingQuranViewSuraName = t.SurahEnglishNames[n - 1];
        }), previousJuzPara != a && ($(".b_juz").text("Juz " + a), previousJuzPara = a);
        break;
      }
    });
  }));
});